// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-09T16:38:03.085Z
// Property: Mosaic at Miramar Town Center (ID: 5174219562287104)
// Collections: 21 amenities, 41 floorplans (live), 30 photos, 84 POIs, 7 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5174219562287104",
  "property_external_id": "4980088",
  "property_zillow_url": "https://www.zillow.com/apartments/miramar-fl/mosaic-at-miramar/5fvKJb/",
  "property_apartments_url": "https://www.apartments.com/mosaic-at-miramar-town-center-miramar-fl/bp6tjyc",
  "property_google_business_url": "https://www.google.com/maps/place/Mosaic+at+Miramar+Town+Center/@25.9861309,-80.2981975,15z/data=!4m2!3m1!1s0x0:0x923a43d109046c52?sa=X&ved=2ahUKEwiXoeyj2v_2AhUEomoFHRcOCTQQ_BJ6BAhJEAU",
  "property_linkedin_url": null,
  "property_hubspot_id": "8384315033",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "mosaic-at-miramar-town-center",
  "property_name": "Mosaic at Miramar Town Center",
  "property_website_url": "https://www.mosaicatmiramar.com/",
  "property_domain": "https://www.mosaicatmiramar.com/",
  "property_address": "11575 City Hall Promenade",
  "property_full_address": "11575 City Hall Promenade, Miramar, FL 33025",
  "property_address_1": "11575 City Hall Promenade",
  "property_address_2": null,
  "property_address_city": "Miramar",
  "property_address_state": "FL",
  "property_address_zip_full": "33025-7582",
  "property_address_zip": "33025",
  "property_address_country": "US",
  "property_address_county": "Broward County",
  "property_neighborhood_address": "Miramar",
  "property_address_latitude": "25.9856869",
  "property_address_longitude": "-80.29843919999999",
  "property_email": "mosaic@alapts.com",
  "property_phone": "(954) 499-0502",
  "property_call_tracking_phone": "754-255-4636",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Live at the center of Miramar’s everyday energy.</strong> Mosaic at Miramar Town Center offers polished apartments and townhome-style layouts with condo-inspired finishes, walkable conveniences, and easy South Florida connections. Explore spacious floor plans and schedule your tour today.</p>",
  "property_long_description": "<p><strong>Live at the center of Miramar’s everyday energy.</strong> Mosaic at Miramar Town Center pairs polished one-, two-, and three-bedroom apartments and townhome-style layouts with the walkable feel of a civic-and-retail destination. Inside, you’ll find condo-inspired finishes like granite countertops, stainless steel appliances, in-home washers and dryers, generous walk-in closets, and private patios or balconies in select homes.</p><p>Beyond your front door, <a href=\"/amenities\">community amenities</a> bring the day into focus: a resort-style pool, 24-hour fitness center, clubhouse WiFi, resident lounge, controlled access, and on-site retail conveniences. The setting is just as compelling, with Miramar City Hall, the Miramar Cultural Center | ArtsPark, the library, and City Hall Promenade dining close by, plus easy connections to Red Road, Miramar Parkway, I-75, and the Turnpike. Explore <a href=\"/floor-plans\">spacious floor plans</a> designed for a connected South Florida lifestyle.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019d02ee-8ea8-760f-8f1a-8572a41abc09.webp",
  "property_featured_image_media": {
    "alt_text": "Living room with a TV, sofa, accent chairs, coffee tables, and a balcony view.",
    "public_id": "019d02ee-8ea8-760f-8f1a-8572a41abc09",
    "storage_key": "property/5174219562287104/019d02ee-8ea8-760f-8f1a-8572a41abc09.webp",
    "width": 1240,
    "height": 826
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "487",
  "property_year_built": "2015",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.5359342915811",
  "property_admin_fee": "350",
  "property_application_fee": "150",
  "property_fees_deposit_info": "Application Fee $150\nAdministrative Fee $350\nNon-Refundable Pet Fee $550 / pet\nMonthly Pet Rent $35 / pet\nApplication Approval Fee Starting At $399\n",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "550",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $550 per pet, with a monthly pet rent of $35 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $550 per pet, with a monthly pet rent of $35 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8878326.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://mosaicatmiramartowncenterfl.loftliving.com/login",
  "property_apply_now_url": "https://8878326.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e6ff2-24b3-75f1-9ef2-3c1a4c798498.webp",
  "property_primary_logo_media": {
    "alt_text": "Mosaic at Miramar Town Center logo",
    "public_id": "019e6ff2-24b3-75f1-9ef2-3c1a4c798498",
    "storage_key": "property/5174219562287104/019e6ff2-24b3-75f1-9ef2-3c1a4c798498.webp",
    "width": 184,
    "height": 200
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019d02f0-0d9e-707c-a266-681a6e87dc45.webp",
  "property_secondary_logo_media": {
    "alt_text": "Black screen",
    "public_id": "019d02f0-0d9e-707c-a266-681a6e87dc45",
    "storage_key": "property/5174219562287104/019d02f0-0d9e-707c-a266-681a6e87dc45.webp",
    "width": 5,
    "height": 5
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e6ff2-31da-7454-949c-b690b9bbcda5.webp",
  "property_icon_media": {
    "alt_text": "Black and white logo with letters IM",
    "public_id": "019e6ff2-31da-7454-949c-b690b9bbcda5",
    "storage_key": "property/5174219562287104/019e6ff2-31da-7454-949c-b690b9bbcda5.webp",
    "width": 3072,
    "height": 3072
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e6ff2-31da-7454-949c-b690b9bbcda5.webp",
  "property_fav_icon_media": {
    "alt_text": "Black and white logo with letters IM",
    "public_id": "019e6ff2-31da-7454-949c-b690b9bbcda5",
    "storage_key": "property/5174219562287104/019e6ff2-31da-7454-949c-b690b9bbcda5.webp",
    "width": 3072,
    "height": 3072
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e6ff2-36a7-7489-9de7-1257553b61f4.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Mosaic at Miramar Town Center logo",
    "public_id": "019e6ff2-36a7-7489-9de7-1257553b61f4",
    "storage_key": "property/5174219562287104/019e6ff2-36a7-7489-9de7-1257553b61f4.webp",
    "width": 2892,
    "height": 3072
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f430e-d07b-74f4-a508-7ff675c2bf17.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f430e-d07b-74f4-a508-7ff675c2bf17",
    "storage_key": "property/5174219562287104/019f430e-d07b-74f4-a508-7ff675c2bf17.webp",
    "width": 184,
    "height": 200
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#4a4745",
  "property_secondary_color": "#958e8a",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#3e3e3e",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "700 - 1566",
  "property_sqft_min": "700",
  "property_sqft_max": "1566",
  "property_price_range": "2173.83 - 3511.5",
  "property_price_min": "2173.83",
  "property_price_max": "3511.5",
  "property_available_units": 12,
  "property_facebook_url": "https://www.facebook.com/MosaicMiramarTownCenter",
  "property_instagram_url": "https://www.instagram.com/mosaicatmiramartowncenter",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJtcWFBuil2YgRUmwECdFDOpI",
  "property_youtube_url": "https://www.youtube.com/watch?v=Yii3AqPYoF0",
  "property_yelp_url": "https://www.yelp.com/biz/miramar-town-center-miramar-3",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Polished amenities, right on your schedule.</strong> Break a sweat in the 24-hour fitness center, unwind by the resort-style pool and sundeck, or shift gears in the resident lounge, WiFi-enabled clubhouse, and conference room. Controlled access, on-site retail, online resident services, and available concierge support add everyday ease, while apartment features like granite countertops, stainless steel appliances, in-home laundry, walk-in closets, and select private outdoor spaces keep comfort close.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with room to choose.</strong> Mosaic at Miramar Town Center offers one-, two-, and three-bedroom apartments, plus select townhome-style layouts with added separation and extra bath space. Inside, find polished finishes like granite countertops, stainless steel appliances, in-home washer and dryer, walk-in closets, 9-foot ceilings, and private patios or balconies in select homes.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a glimpse of Mosaic at Miramar Town Center.</strong> Preview sunlit interiors with balcony access, granite countertops, stainless steel appliances, oversized windows, and smart closet storage. Then picture the community around them: palm-lined pool views, polished clubhouse lounges, a coffee-bar-style kitchen, billiards, fitness spaces, and inviting courtyard moments—all waiting in the full photo gallery.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Live in the center of Miramar’s everyday energy.</strong> Mosaic places you near City Hall Promenade dining, coffee, civic campus culture, gallery moments, and the ArtsPark botanical garden. For broader plans, connect to the Town Center Transportation Hub, Red Road, Miramar Parkway, I-75, and the Florida Turnpike, with Miramar Regional Park and Ansin Sports Complex close by for open-air time.</p>",
  "property_home_reviews_blurb": "<p><strong>Resident-loved details, every day.</strong><br>Reviews for Mosaic at Miramar Town Center highlight the things that make home feel effortless: attentive service, prompt maintenance, well-kept surroundings, spacious apartments, and a calm atmosphere. Residents also call out friendly team members, welcoming events, in-home washers and dryers, dishwashers, updated kitchen appliances, and quick access to nearby shopping and dining. See why Mosaic is described as a “phenomenal place to call home.”</p>",
  "property_neighborhood_blurb": "<p><strong>Map your day from a true Miramar town-center setting.</strong> From Mosaic, you’re close to the area’s civic campus, where live performances, gallery moments, and the ArtsPark botanical garden add culture to the everyday rhythm. Along City Hall Promenade, dinner at El Churrascaso, casual coffee stops, and neighboring services make quick outings feel easy.</p><p>When you want to go farther, the Town Center Transportation Hub connects with Miramar’s free community shuttle, while Red Road, Miramar Parkway, I-75, and the Florida Turnpike keep South Florida within reach. Spend open-air time at Miramar Regional Park, catch a meet at Ansin Sports Complex, or return home to unwind by the <a href=\"/amenities\">pool and lounge spaces</a>. Ready to explore it in person? <a href=\"/schedule-a-tour\">Schedule a tour</a> and see the neighborhood around Mosaic.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that work beautifully around your routine.</strong> Mosaic at Miramar Town Center gives you polished spaces to recharge, connect, and get things done without leaving the community. Start with the 24-hour fitness center, cool off at the resort-style pool and sundeck, or settle into the resident lounge, clubhouse WiFi, and conference room when you need a change of scenery.</p><p>Everyday details feel just as considered, from controlled access and on-site retail to 24/7 online resident services, Updater moving support, and available Spruce concierge services. Inside your home, granite countertops, stainless steel appliances, in-home laundry, walk-in closets, and select kitchen islands or private outdoor spaces bring comfort into focus. Browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Mosaic home?</strong><br>Start your application online for polished one-, two-, and three-bedroom apartments and townhome-style layouts with condo-inspired finishes, in-home washers and dryers, generous walk-in closets, and select private patios or balconies—all set in the walkable energy of Miramar Town Center.</p>",
  "property_contactus_blurb": "<p><strong>Questions? We’re here to help.</strong> Contact the leasing team at Mosaic at Miramar Town Center for details on one-, two-, and three-bedroom apartments and townhome-style layouts, or for directions to our walkable City Hall Promenade setting in Miramar.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Mosaic at Miramar Town Center?</strong> Start here for quick answers about the community, leasing, apartment features, amenities, and everyday living in the center of Miramar’s walkable civic-and-retail setting. If you need more details, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find your fit at Mosaic.</strong> Browse a deep collection of one-, two-, and three-bedroom apartment floor plans, including select townhome-style layouts with added separation and extra bath space. Whether you want a streamlined one-bedroom, a split two-bedroom design, or a larger three-bedroom home, each option is built around everyday comfort in Miramar.</p><p>Inside, look for polished details that make the layout work harder for you: <strong>granite countertops, stainless steel appliances, in-home washer and dryer, walk-in closets, tile flooring, 9-foot ceilings, and private patios or balconies in select homes</strong>. Some plans also feature kitchen islands for a more open, connected living space. Compare current pricing and availability below, then explore more <a href=\"/amenities\">apartment features</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your preferred layout in person.</p>",
  "property_gallery_blurb": "<p><strong>See the spaces before you arrive.</strong> Browse the Mosaic at Miramar Town Center photo gallery for sunlit living rooms that open to balconies, kitchens framed by granite countertops and stainless steel appliances, and bedrooms with oversized windows and easy closet storage.</p><p>Move from indoor details to the full community picture: palm-lined pool scenes, lounge seating beneath polished clubhouse finishes, a coffee-bar-style community kitchen, billiards, fitness spaces, and courtyard moments. If a photo sparks your shortlist, compare <a href=\"/floor-plans\">floor plan layouts</a>, explore more <a href=\"/amenities\">amenity details</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Mosaic in Miramar for yourself.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore what’s around Mosaic.</strong> Use the interactive map to browse available apartments and see how this Miramar Town Center setting connects you to City Hall Promenade dining, civic and cultural destinations, and quick routes via Red Road, Miramar Parkway, I-75, and the Turnpike.</p>",
  "property_pets_blurb": "<p><strong>Pets belong in the Mosaic rhythm.</strong> Start the day with a leash walk through the town-center setting, then come home to apartment spaces that make everyday care easier—think in-home washers and dryers, generous closet storage, and select private patios or balconies for a breath of fresh air.</p><p>Cats and dogs are welcome here, with room to choose the layout that suits your routine. Around the community, landscaped courtyards, controlled-access entries, and convenient on-site retail help simplify quick breaks and errands, while Paw Central Dog Park is a short drive away when your pup needs off-leash time. Explore our <a href=\"/floor-plans\">available floor plans</a> or view more <a href=\"/amenities\">pet-friendly conveniences</a> at Mosaic at Miramar Town Center.</p>",
  "property_referafriend_blurb": "<p><strong>Share the everyday energy of Mosaic.</strong> Invite a friend to discover polished apartments and townhome-style layouts, condo-inspired finishes, private patios or balconies in select homes, and a connected Miramar Town Center setting that keeps daily conveniences close.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Mosaic at Miramar Town Center.</strong><br>Log in to pay rent, submit maintenance requests, and manage your account—so everyday details stay as polished and connected as your apartment living experience.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents appreciate most.</strong><br>At Mosaic at Miramar Town Center, reviews often point to the everyday details that make apartment living feel easy: attentive service, well-maintained surroundings, spacious homes, and a calm atmosphere. Residents praise the team as “super friendly and very attentive,” with maintenance requests handled promptly and resident events adding a welcoming sense of connection.</p><p>You’ll also see recurring mentions of modern in-home conveniences like washers, dryers, dishwashers, updated kitchen appliances, plus easy access to shopping and restaurants nearby. Read the reviews below to see why residents describe Mosaic as a “phenomenal place to call home.”</p>",
  "property_created_at": "1752256299669",
  "property_scheduletour_blurb": "<p><strong>See Mosaic at Miramar Town Center up close.</strong> Tour polished one-, two-, and three-bedroom apartments and townhome-style layouts with granite countertops, stainless steel appliances, walk-in closets, and select private patios or balconies. Then step into the walkable civic-and-retail setting that brings everyday convenience into focus. Schedule your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>Our leasing team will follow up soon. In the meantime, picture polished one-, two-, and three-bedroom apartments and townhome-style layouts with granite countertops, stainless steel appliances, walk-in closets, and a connected Miramar Town Center setting that keeps everyday essentials close.</p>",
  "property_virtualtours_blurb": "<p><strong>Tour Mosaic on your time.</strong> Step into the spaces before you schedule a visit, from the community video to immersive looks at the clubhouse and fitness center. Then move through available apartment tours, including A1 and A3 one-bedroom layouts, B3, B6, and B9 two-bedroom options, plus T1 and T2 townhome-style homes with added separation.</p><p>As you click through, notice the details that are easier to understand in motion: open living areas, granite-topped kitchens, stainless steel appliances, natural light, walk-in closet space, in-home laundry, and select balconies or patios. Compare the tours with current <a href=\"/floor-plans\">floor plan options</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Mosaic at Miramar Town Center in person.</p>",
  "property_copyright": "2025 All Rights Reserved. Mosaic at Miramar Town Center",
  "property_seo_title_home": "Mosaic at Miramar Town Center | Apartments in Miramar, FL",
  "property_seo_description_home": "\"Step into the vibrant lifestyle at Mosaic at Miramar Town Center, where luxury meets comfort in stylish one, two, and three-bedroom apartments. Enjoy resort-style amenities like a sparkling pool, fitness center, and serene water views right at your doorstep. With top-notch features like walk-in closets, modern kitchen islands, and online resident services, your perfect home awaits in the heart of Miramar, FL. Find your new sanctuary today!\"",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Miramar, FL",
  "property_seo_description_floorplans": "Experience the vibrant lifestyle at Mosaic at Miramar Town Center, where our thoughtfully designed one, two, and three-bedroom apartments cater to your unique needs. Whether you're seeking a cozy retreat or a spacious haven, our diverse floor plans offer the ideal backdrop for your life in Miramar, FL. Browse our options today and step into your dream home!",
  "property_seo_title_amenities": "Amenities | Miramar, FL Apartments for Rent",
  "property_seo_description_amenities": "Experience the vibrant lifestyle at Mosaic at Miramar Town Center in sunny Miramar, FL. Our upscale community offers a variety of thoughtfully designed one, two, and three-bedroom floor plans, complete with modern amenities like a state-of-the-art fitness center, sparkling pool, and relaxing outdoor spaces. Enjoy the convenience of access gates, online resident services, and a resident convenience store, all while surrounded by stunning views of the lake, fountains, and playgrounds. Elevate your living experience today—your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Miramar, FL",
  "property_seo_description_gallery": "Unveil your next home at Mosaic at Miramar Town Center, where vibrant living meets modern comfort in the heart of Miramar, FL. Browse through our stunning photo gallery and visualize your life in spacious one, two, or three-bedroom apartments. Enjoy premium amenities like a refreshing pool, state-of-the-art fitness center, and serene water views—all designed for your convenience and pleasure. Picture yourself relaxing on the top floor or hosting friends in our lounge or playground. Your new lifestyle awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Mosaic at Miramar Town Center Apartments",
  "property_seo_description_virtualtours": "Experience the vibrant lifestyle at Mosaic at Miramar Town Center, where modern comfort meets an unbeatable location in Miramar, FL. Our diverse floor plans—including one, two, and three-bedroom options—cater to every need. Dive into an immersive virtual tour of our beautifully designed apartments and inviting community spaces. Your perfect home awaits—join us online today!",
  "property_seo_title_interactivemap": "Interactive Map | Mosaic at Miramar Town Center Apartments",
  "property_seo_description_interactivemap": "Unravel the charm of Mosaic at Miramar Town Center, where modern living meets vibrant community life in the heart of Miramar, FL. Our spacious one, two, and three-bedroom floor plans come complete with top-notch amenities, including a state-of-the-art fitness center, inviting pool, and picturesque water views. Use our interactive community map to effortlessly search available apartments, explore pricing, and envision your dream home. Welcome to a lifestyle defined by comfort and convenience!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Miramar, FL",
  "property_seo_description_neighborhood": "Uncover the vibrant lifestyle awaiting you at Mosaic at Miramar Town Center! Nestled in the heart of Miramar, FL, our community offers a seamless blend of comfort and convenience. From trendy cafés to lush parks, our neighborhood is brimming with local favorites and key attractions that cater to your every need. Dive into the sights and sounds around you—your best adventure starts just outside your door!",
  "property_seo_title_contact": "Contact Us | Mosaic at Miramar Town Center",
  "property_seo_description_contact": "\"Connect with Mosaic at Miramar Town Center in sunny Miramar, FL! Whether you're searching for a chic one-bedroom haven, a spacious two-bedroom retreat, or a luxurious three-bedroom escape, our diverse floor plans cater to your lifestyle. Have questions? Our friendly leasing team is ready to help you find your perfect home. Reach out today!\"",
  "property_seo_title_faqs": "FAQs | Apartments in Miramar, FL",
  "property_seo_description_faqs": "Welcome to Mosaic at Miramar Town Center, where luxury meets convenience in the heart of Miramar, FL. Our diverse one-, two-, and three-bedroom apartments offer stunning views and modern amenities, including a refreshing pool, top-notch fitness center, and elegant kitchen islands. Have questions? Our FAQs page is your go-to resource for everything you need to know about living in our vibrant community. Dive in to learn about our access gates, resident convenience store, and the stunning playground views that await you!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Miramar, FL",
  "property_seo_description_reviews": "\"At Mosaic at Miramar Town Center in sunny Miramar, FL, residents enjoy upscale living with stunning water and fountain views, modern amenities, and thoughtful design. From spacious floor plans to top-notch conveniences like a fitness center and resident lounge, our community offers a lifestyle that elevates your everyday experiences. Ready to hear real stories from our happy residents? Dive into their reviews and see why Mosaic is the perfect place to call home!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Miramar, FL",
  "property_seo_description_applynow": "\"Become part of the vibrant Mosaic at Miramar Town Center community in Miramar, FL! Choose from thoughtfully designed one, two, and three-bedroom floor plans, complete with upscale amenities like a sparkling pool, fitness center, and serene water views. Enjoy online resident services, convenient access gates, and a playground for the little ones—all within a premium location. Your perfect home awaits. Lease online today and experience elevated living!\"",
  "property_seo_title_residentaccess": "Resident Access | Mosaic at Miramar Town Center",
  "property_seo_description_residentaccess": "\"Welcome to the Mosaic at Miramar Town Center resident portal! Effortlessly manage your living experience in Miramar, FL—pay rent, schedule maintenance, and connect with your vibrant community. Your convenient lifestyle starts here!\"",
  "property_seo_title_referafriend": "Refer A Friend | Mosaic at Miramar Town Center",
  "property_seo_description_referafriend": "Refer a friend to Mosaic at Miramar Town Center – where vibrant living meets unparalleled community! Share the joy of our stylish apartments and exceptional amenities in Miramar, FL. Great friends make great neighbors — spread the love and join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Mosaic at Miramar Town Center",
  "property_seo_description_scheduletour": "Experience the vibrant lifestyle at Mosaic at Miramar Town Center, where modern elegance meets local charm. Immerse yourself in our stunning amenities and inviting atmosphere—schedule your tour today and envision your future home in beautiful Miramar, FL!",
  "property_seo_title_privacy": "Privacy Policy | Mosaic at Miramar Town Center",
  "property_seo_description_privacy": "\"At Mosaic at Miramar Town Center, your privacy is our priority. Dive into our comprehensive privacy policy to understand how we safeguard your information while you enjoy all the vibrant amenities and community features that make us exceptional. Your peace of mind is just a click away!\"",
  "property_seo_title_accessibility": "Website Accessibility | Mosaic at Miramar Town Center",
  "property_seo_description_accessibility": "\"At Mosaic at Miramar Town Center, we're committed to making every experience seamless for our residents. Our Accessibility Statement underscores our dedication to digital inclusion, ensuring everyone can enjoy the vibrant lifestyle Miramar has to offer. Join us in creating a welcoming community where everyone feels at home.\"",
  "property_seo_title_sitemap": "Sitemap | Mosaic at Miramar Town Center",
  "property_seo_description_sitemap": "Uncover the vibrant community at Mosaic at Miramar Town Center! From lush living spaces to top-tier amenities, our sitemap guides you through every opportunity for living, lounging, and enjoying life in sunny Miramar, FL. Find your perfect home today!",
  "property_seo_title_thankyou": "Thank You | Mosaic at Miramar Town Center",
  "property_seo_description_thankyou": "Thank you for reaching out to Mosaic at Miramar Town Center! Your interest is valued, and our dedicated team is excited to help you find your perfect home in vibrant Miramar, FL. Expect a friendly response soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Riverview, FL",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234320013",
  "amenities": [
    {
      "id": "custom_437f5c13-e76a-40d4-a8bf-67e54873616b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "external_id": "P000000594",
      "title": "Access Gates",
      "amount": "0.0000",
      "description": "Controlled Access Gates",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_715ca647-a0c7-4c83-997d-8759f8591a75",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "external_id": "P000000596",
      "title": "Alarms",
      "amount": "0.0000",
      "description": "Security System Offered*",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_33617c2e-61fb-4558-b53e-6b2aaf16c0c8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cceda5c1-0a16-452c-8e58-ee18b69fe477",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "external_id": "P000000606",
      "title": "Built-In Microwave",
      "amount": "0.0000",
      "description": "Built-In Microwave",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e0867bd5-461e-4178-8837-85ced8be49d9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Sleek Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_49c60d3f-686a-443a-a050-6a5268c2c45d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern 24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d73690ea-92e6-450a-a241-becfe745064e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Tile Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1e147ce3-d71e-4de7-a6ae-1eb23a9691a9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a18e5295-36cc-4f2e-aaac-31e38aee3af3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "external_id": "P000000652",
      "title": "Kitchen Islands",
      "amount": "0.0000",
      "description": "Kitchen Islands*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4cca17ca-44a4-4b2d-a2da-9a5577c23590",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f123d4f1-d064-49d5-87bd-f4a657cd0d7f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios and Balconies",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1e453bda-5c13-4bee-8e8a-496d7f874d6a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "external_id": "P000000668",
      "title": "Playground",
      "amount": "0.0000",
      "description": "Playground",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2ed771f2-f0d1-4678-af65-a483fd466216",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Inspired Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_97ec7a7e-e6a7-43ed-9c95-7d62e2e4aed8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_39045d81-8752-47a7-b4a9-e7f927035cee",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Generous Walk-In Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e9e9ed23-7ada-4201-be59-33c24399e2f1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "external_id": "P000000708",
      "title": "Wifi",
      "amount": "0.0000",
      "description": "WiFi Access in Clubhouse",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_705080a5-2622-4991-8acf-5e01ac42eebb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "external_id": "P000001372",
      "title": "Lounge",
      "amount": "0.0000",
      "description": "Resident Lounge",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_da95139a-51f7-4357-85fe-213e841b2296",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "external_id": "P000002334",
      "title": "Resident Convenience Store",
      "amount": "0.0000",
      "description": "Resident Convenience Store",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7dd67254-3e49-4b72-ba42-e404ef4ca978",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "external_id": "P000002365",
      "title": "Conference Room",
      "amount": "0.0000",
      "description": "Resident Conference Room",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6d91aa4d-d4b5-44c1-bdb1-1fc2e46a4c40",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "external_id": "P000002562",
      "title": "Updater",
      "amount": "0.0000",
      "description": "Digital Moving Concierge Services by Updater",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_14b1b9ae-88b1-4dde-96ec-15000fc3f848",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "external_id": "P000002563",
      "title": "Spruce",
      "amount": "0.0000",
      "description": "Spruce",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_564de3c3-1da7-4568-869b-9062f40b64ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-d300-764d-8247-7d04e9b8ef04.webp",
      "image_media": {
        "alt_text": "Modern living room with two curved white sofas, a textured round coffee table, and abstract art.",
        "public_id": "019e89a4-d300-764d-8247-7d04e9b8ef04",
        "storage_key": "property/5174219562287104/019e89a4-d300-764d-8247-7d04e9b8ef04.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed living space featuring plush seating, a unique coffee table, and elegant decor, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern living room with two curved white sofas, a textured round coffee table, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_68caa2c4-a923-4673-94f6-29e1acbc571d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-cd2b-705d-a996-b384fca3ada1.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019e89a4-cd2b-705d-a996-b384fca3ada1",
        "storage_key": "property/5174219562287104/019e89a4-cd2b-705d-a996-b384fca3ada1.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush palm trees and comfortable lounge seating. Perfect for relaxation and sunny days.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0334b6f4-2efd-4394-9824-6210f22bee18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-c973-72ae-ac80-11734223c8fb.webp",
      "image_media": {
        "alt_text": "Two billiard tables in a community lounge with bar seating and a lounge area in the background.",
        "public_id": "019e89a4-c973-72ae-ac80-11734223c8fb",
        "storage_key": "property/5174219562287104/019e89a4-c973-72ae-ac80-11734223c8fb.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy a friendly game of billiards in our resident lounge, featuring two full-sized tables and a comfortable seating area.",
      "link": "",
      "alt_text": "Two billiard tables in a community lounge with bar seating and a lounge area in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7a98eb86-86ea-4548-bdab-65a1b971bcfc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-cbb5-7517-af53-b21108e37bed.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, toilet, and vanity with granite countertop.",
        "public_id": "019e89a4-cbb5-7517-af53-b21108e37bed",
        "storage_key": "property/5174219562287104/019e89a4-cbb5-7517-af53-b21108e37bed.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Step into comfort with this stylish bathroom, featuring a pristine bathtub, a sleek toilet, and a spacious vanity topped with elegant granite.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, toilet, and vanity with granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8f912439-ee8d-4137-bd96-47cae1e3a870",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-d096-76fe-889d-0d500c7b96df.webp",
      "image_media": {
        "alt_text": "Bedroom with a walk-in closet and a bed.",
        "public_id": "019e89a4-d096-76fe-889d-0d500c7b96df",
        "storage_key": "property/5174219562287104/019e89a4-d096-76fe-889d-0d500c7b96df.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "This apartment bedroom features a spacious walk-in closet and a comfortable bed. Enjoy ample storage and a relaxing space.",
      "link": "",
      "alt_text": "Bedroom with a walk-in closet and a bed.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e1831788-138c-489b-8fb5-6944a64e7710",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-c71d-77cd-b77f-f38a1f387956.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, weight machines, and free weights.",
        "public_id": "019e89a4-c71d-77cd-b77f-f38a1f387956",
        "storage_key": "property/5174219562287104/019e89a4-c71d-77cd-b77f-f38a1f387956.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines, strength training equipment, and free weights for residents.",
      "link": "",
      "alt_text": "Gym with treadmills, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c714ab39-3987-4d8b-89a6-12ae62ff03c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-cabf-703d-a746-5b285bc36d82.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and dark wood cabinetry.",
        "public_id": "019e89a4-cabf-703d-a746-5b285bc36d82",
        "storage_key": "property/5174219562287104/019e89a4-cabf-703d-a746-5b285bc36d82.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen, perfect for home chefs. Features granite countertops, stainless steel appliances, and ample cabinet space.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and dark wood cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3a79eaaa-b1da-407b-ad57-26a2e3cf703d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-be4a-724f-a4d4-7b100e5da719.webp",
      "image_media": {
        "alt_text": "Lounge area with bar seating, sofas, and a TV.",
        "public_id": "019e89a4-be4a-724f-a4d4-7b100e5da719",
        "storage_key": "property/5174219562287104/019e89a4-be4a-724f-a4d4-7b100e5da719.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and unwind in the stylish lounge area, featuring comfortable seating, a modern bar, and entertainment options.",
      "link": "",
      "alt_text": "Lounge area with bar seating, sofas, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d065f596-0a1c-4e67-bcad-522223518dcb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-b937-760c-8f14-7d20fe166f14.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment with a sofa, chairs, and modern kitchen.",
        "public_id": "019e89a4-b937-760c-8f14-7d20fe166f14",
        "storage_key": "property/5174219562287104/019e89a4-b937-760c-8f14-7d20fe166f14.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Stylish living room and open-concept kitchen featuring a comfortable sofa, accent chairs, and sleek cabinetry. Perfect for modern living.",
      "link": "",
      "alt_text": "Living room and kitchen area of an apartment with a sofa, chairs, and modern kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ea008f9e-ead0-4a16-8065-b58ce2291fb0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-c0ee-72c0-805f-89c3ac6006d6.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed and a view of the bathroom.",
        "public_id": "019e89a4-c0ee-72c0-805f-89c3ac6006d6",
        "storage_key": "property/5174219562287104/019e89a4-c0ee-72c0-805f-89c3ac6006d6.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a queen-size bed with plush bedding and a vibrant green throw blanket. An adjoining bathroom is visible through the open doorway.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed and a view of the bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_74360b1c-5347-468c-bb83-7212b273814f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-b808-7498-ae09-8859efbe77b0.webp",
      "image_media": {
        "alt_text": "Bar with seating and coffee station.",
        "public_id": "019e89a4-b808-7498-ae09-8859efbe77b0",
        "storage_key": "property/5174219562287104/019e89a4-b808-7498-ae09-8859efbe77b0.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Modern community coffee bar with seating, coffee maker, and refrigerator.",
      "link": "",
      "alt_text": "Bar with seating and coffee station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fade63ab-82e6-4aa1-bd55-b8a72c8eed80",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-b688-74dd-9858-febb3dd2f381.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with island, sofa, and balcony view.",
        "public_id": "019e89a4-b688-74dd-9858-febb3dd2f381",
        "storage_key": "property/5174219562287104/019e89a4-b688-74dd-9858-febb3dd2f381.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Open-concept living space featuring a stylish kitchen with granite countertops and stainless steel appliances, adjacent to a comfortable living area and balcony access.",
      "link": "",
      "alt_text": "Modern kitchen and living area with island, sofa, and balcony view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_243d110c-1e2f-4514-8694-10fa0935d509",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-b5c6-741f-b3d5-ca6d51b11a88.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with green sofa, coffee table, and modern decor.",
        "public_id": "019e89a4-b5c6-741f-b3d5-ca6d51b11a88",
        "storage_key": "property/5174219562287104/019e89a4-b5c6-741f-b3d5-ca6d51b11a88.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed resident lounge, featuring comfortable seating, a large television, and elegant decorative accents.",
      "link": "",
      "alt_text": "Stylish lounge area with green sofa, coffee table, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4cc00093-2405-4421-b384-46aa3e1c3ee6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-addb-7148-b449-149aacfe2fa7.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, weight machines, and dumbbells.",
        "public_id": "019e89a4-addb-7148-b449-149aacfe2fa7",
        "storage_key": "property/5174219562287104/019e89a4-addb-7148-b449-149aacfe2fa7.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center features a variety of cardio machines and strength training equipment to help you achieve your wellness goals.",
      "link": "",
      "alt_text": "Gym with treadmills, weight machines, and dumbbells.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4967d2a7-1742-4b05-b028-a43e032a15fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-aded-719c-bed9-9725bf65b9b0.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019e89a4-aded-719c-bed9-9725bf65b9b0",
        "storage_key": "property/5174219562287104/019e89a4-aded-719c-bed9-9725bf65b9b0.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our sparkling swimming pool, complete with comfortable lounge chairs and lush tropical landscaping.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_03712d16-f126-4f91-bddf-e7e2c9c8e8cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-add6-75ac-a574-b2eb1bcdb897.webp",
      "image_media": {
        "alt_text": "A staged bedroom with a queen-size bed, modern decor, and a large window.",
        "public_id": "019e89a4-add6-75ac-a574-b2eb1bcdb897",
        "storage_key": "property/5174219562287104/019e89a4-add6-75ac-a574-b2eb1bcdb897.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Spacious and elegantly designed bedroom featuring a comfortable queen-size bed, stylish accent pillows, and a large window with blinds, creating a serene and inviting atmosphere.",
      "link": "",
      "alt_text": "A staged bedroom with a queen-size bed, modern decor, and a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dd6550a9-41ad-4a9c-b4a9-56201025df2e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-ac5f-774a-b9c9-e712eb054e14.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and an island.",
        "public_id": "019e89a4-ac5f-774a-b9c9-e712eb054e14",
        "storage_key": "property/5174219562287104/019e89a4-ac5f-774a-b9c9-e712eb054e14.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed apartment kitchen, featuring dark wood cabinetry, granite countertops, and stainless steel appliances. An island provides extra prep space and seating, perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and an island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ccf43e41-4b75-4ab4-8192-169ac8d8039e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-a457-7488-98a1-8230aa297823.webp",
      "image_media": {
        "alt_text": "Modern living room with grey brick accent wall, plush sofa, and accent chairs.",
        "public_id": "019e89a4-a457-7488-98a1-8230aa297823",
        "storage_key": "property/5174219562287104/019e89a4-a457-7488-98a1-8230aa297823.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed living room, featuring a stylish grey brick accent wall, a comfortable sofa, and chic accent chairs, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Modern living room with grey brick accent wall, plush sofa, and accent chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_377df9f5-ce4c-4279-9c04-71415fb616b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-a310-7573-a251-844d10008c87.webp",
      "image_media": {
        "alt_text": "Spacious community room with mirrors, seating, and bar.",
        "public_id": "019e89a4-a310-7573-a251-844d10008c87",
        "storage_key": "property/5174219562287104/019e89a4-a310-7573-a251-844d10008c87.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "This versatile community room features a mirrored wall, comfortable seating areas, and a high-top bar, perfect for resident gatherings or events.",
      "link": "",
      "alt_text": "Spacious community room with mirrors, seating, and bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ec199a79-0d55-45a0-aa22-7c36e71a06e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-a034-70e8-ba62-213b0268956c.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with dark cabinetry, stainless steel appliances, and island.",
        "public_id": "019e89a4-a034-70e8-ba62-213b0268956c",
        "storage_key": "property/5174219562287104/019e89a4-a034-70e8-ba62-213b0268956c.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Stylish dining area and open-concept kitchen featuring dark wood cabinetry, stainless steel appliances, and a granite-topped island with bar seating.",
      "link": "",
      "alt_text": "Dining area and kitchen with dark cabinetry, stainless steel appliances, and island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_aaff9829-d1f0-4e05-8991-90eaeeca4dd3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-a14f-70cc-87dd-6e6c086ea7c3.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with a full kitchen, comfortable seating, and a large TV.",
        "public_id": "019e89a4-a14f-70cc-87dd-6e6c086ea7c3",
        "storage_key": "property/5174219562287104/019e89a4-a14f-70cc-87dd-6e6c086ea7c3.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully designed resident lounge, complete with a gourmet kitchen, ample seating, and entertainment options.",
      "link": "",
      "alt_text": "Stylish lounge area with a full kitchen, comfortable seating, and a large TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6f0e508a-a027-4662-8578-b33cbec0f1b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-9b25-707a-8a3f-7f6cc8977195.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and outdoor seating, surrounded by palm trees and apartment buildings.",
        "public_id": "019e89a4-9b25-707a-8a3f-7f6cc8977195",
        "storage_key": "property/5174219562287104/019e89a4-9b25-707a-8a3f-7f6cc8977195.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with comfortable lounge chairs and convenient outdoor seating. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and outdoor seating, surrounded by palm trees and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a93a3496-7db0-4978-bf86-7f7200ed4a9a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-9a6c-7019-a2e0-ed9f1a03e7d3.webp",
      "image_media": {
        "alt_text": "Self-serve coffee and beverage bar with a touchscreen interface, coffee maker, and taps.",
        "public_id": "019e89a4-9a6c-7019-a2e0-ed9f1a03e7d3",
        "storage_key": "property/5174219562287104/019e89a4-9a6c-7019-a2e0-ed9f1a03e7d3.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and beverages at our convenient self-serve coffee bar, perfect for a quick pick-me-up.",
      "link": "",
      "alt_text": "Self-serve coffee and beverage bar with a touchscreen interface, coffee maker, and taps.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2032b159-3d11-4a8b-ba42-6eb5716eb531",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-9087-7032-b9c3-279cca7cc666.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a queen-size bed, plush headboard, side table, and large window.",
        "public_id": "019e89a4-9087-7032-b9c3-279cca7cc666",
        "storage_key": "property/5174219562287104/019e89a4-9087-7032-b9c3-279cca7cc666.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Experience comfort in this beautifully appointed bedroom, featuring a queen-size bed, elegant decor, and ample natural light.",
      "link": "",
      "alt_text": "Modern bedroom with a queen-size bed, plush headboard, side table, and large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_70aa326d-16c3-4115-8cbf-0f5d392c2eaa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-92e8-7161-a4c9-ce45731a5f85.webp",
      "image_media": {
        "alt_text": "Modern bathroom with tub, toilet, vanity, and walk-in closet with hangers.",
        "public_id": "019e89a4-92e8-7161-a4c9-ce45731a5f85",
        "storage_key": "property/5174219562287104/019e89a4-92e8-7161-a4c9-ce45731a5f85.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Experience comfort and convenience in this well-appointed bathroom, featuring a clean tub and shower, modern vanity, and a spacious walk-in closet.",
      "link": "",
      "alt_text": "Modern bathroom with tub, toilet, vanity, and walk-in closet with hangers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_58486815-4374-4a81-984c-952d949ff9a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-9044-73cf-aee1-ec591c0e1c5c.webp",
      "image_media": {
        "alt_text": "Lounge area with a large green sofa, glass coffee table, and bar seating.",
        "public_id": "019e89a4-9044-73cf-aee1-ec591c0e1c5c",
        "storage_key": "property/5174219562287104/019e89a4-9044-73cf-aee1-ec591c0e1c5c.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax in the stylish lounge area featuring plush seating and a modern bar, perfect for socializing.",
      "link": "",
      "alt_text": "Lounge area with a large green sofa, glass coffee table, and bar seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2311e0fb-d383-41ed-a56e-3b4fd98a81e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-90ff-71fe-ae5f-795d383c0cd8.webp",
      "image_media": {
        "alt_text": "Community lounge with pool table, seating, and modern decor.",
        "public_id": "019e89a4-90ff-71fe-ae5f-795d383c0cd8",
        "storage_key": "property/5174219562287104/019e89a4-90ff-71fe-ae5f-795d383c0cd8.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and socialize in the community lounge, featuring a pool table, comfortable seating, and a large screen TV.",
      "link": "",
      "alt_text": "Community lounge with pool table, seating, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_21b8f3bb-3fa1-4f07-bf2b-3a73971427df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-8c06-7386-b45e-6979a9af3ed7.webp",
      "image_media": {
        "alt_text": "Stacked washer and dryer in an apartment bathroom.",
        "public_id": "019e89a4-8c06-7386-b45e-6979a9af3ed7",
        "storage_key": "property/5174219562287104/019e89a4-8c06-7386-b45e-6979a9af3ed7.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Convenient in-unit stacked washer and dryer located in a stylish apartment bathroom.",
      "link": "",
      "alt_text": "Stacked washer and dryer in an apartment bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2402019a-170c-4a36-9edd-a2f21cb08c24",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-87a8-72c5-be59-f775b79b5753.webp",
      "image_media": {
        "alt_text": "Modern bathroom with granite countertop vanity, dark wood cabinets, and a large mirror.",
        "public_id": "019e89a4-87a8-72c5-be59-f775b79b5753",
        "storage_key": "property/5174219562287104/019e89a4-87a8-72c5-be59-f775b79b5753.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed bathroom featuring a spacious vanity with granite countertops, ample storage, and modern fixtures. This space offers both style and functionality.",
      "link": "",
      "alt_text": "Modern bathroom with granite countertop vanity, dark wood cabinets, and a large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ded3dbdc-d8b2-4cc6-a151-b27f8ea1a616",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019e89a4-76cc-7350-bc64-e344d6cc49e9.webp",
      "image_media": {
        "alt_text": "Modern community lounge area with marble-top tables and seating.",
        "public_id": "019e89a4-76cc-7350-bc64-e344d6cc49e9",
        "storage_key": "property/5174219562287104/019e89a4-76cc-7350-bc64-e344d6cc49e9.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring comfortable seating and a modern aesthetic perfect for gathering.",
      "link": "",
      "alt_text": "Modern community lounge area with marble-top tables and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_fe71f7eccb8ae8d85b2eb009",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "El Churrascaso Grill - Miramar",
      "poi_type": "Restaurants",
      "poi_address": "11608 City Hall Promenade, Miramar, FL 33025, USA",
      "poi_short_description": "Warm Brazilian restaurant grilling beef and chicken dishes, plus beer and cocktails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-90ac-70ff-ac7f-f87ad03c3b62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-90ac-70ff-ac7f-f87ad03c3b62",
        "storage_key": "property/5174219562287104/019f1502-90ac-70ff-ac7f-f87ad03c3b62.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://elchurrascasogrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4899984726205141803&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-churrascaso-grill---miramar",
      "poi_latitude": "25.9856223",
      "poi_longitude": "-80.29930759999999",
      "poi_miles_from_property": "427 ft",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 954-885-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a930-758e-b81b-9abbdfcf7e6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a930-758e-b81b-9abbdfcf7e6b",
        "storage_key": "property/5174219562287104/019f1500-a930-758e-b81b-9abbdfcf7e6b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJASDC85ul2YgRKxNMsiU-AEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_446fe0a24ae95edf68c059a9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Juana’s Latin Sports Bar",
      "poi_type": "Restaurants",
      "poi_address": "11602 City Hall Promenade, Miramar, FL 33025, USA",
      "poi_short_description": "Colorful, contemporary sports bar offering Dominican, Puerto Rican & American fare, plus a full bar.",
      "poi_long_description": "Colorful, contemporary sports bar offering Dominican, Puerto Rican & American fare, plus a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-8dec-772e-bf08-35f6621472b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-8dec-772e-bf08-35f6621472b8",
        "storage_key": "property/5174219562287104/019f1502-8dec-772e-bf08-35f6621472b8.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://juanaslatinsportbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2992994021352543732&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "juanas-latin-sports-bar",
      "poi_latitude": "25.9856349",
      "poi_longitude": "-80.2991552",
      "poi_miles_from_property": "456 ft",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 954-399-9646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a94a-756d-9fc1-b9df7f8687bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a94a-756d-9fc1-b9df7f8687bc",
        "storage_key": "property/5174219562287104/019f1500-a94a-756d-9fc1-b9df7f8687bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJQPtHeil2YgR9BWWcTRAiSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "ec_fa695b52b05fc251acad1571",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "ARI Bakery Cafe",
      "poi_type": "Restaurants",
      "poi_address": "11679 City Hall Promenade, Miramar, FL 33025, USA",
      "poi_short_description": "Korean bakery offering a range of pastries and grab-and-go treats, plus Wi-Fi.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-9305-73fb-a11a-899779fda4ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-9305-73fb-a11a-899779fda4ef",
        "storage_key": "property/5174219562287104/019f1502-9305-73fb-a11a-899779fda4ef.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://arikorea.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5676402281557600861&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ari-bakery-cafe",
      "poi_latitude": "25.9861435",
      "poi_longitude": "-80.2992767",
      "poi_miles_from_property": "151 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 754-260-5125",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a930-758e-b81b-9abbdfcf7e6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a930-758e-b81b-9abbdfcf7e6b",
        "storage_key": "property/5174219562287104/019f1500-a930-758e-b81b-9abbdfcf7e6b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8YQ99vOl2YgRXSp12syhxk4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "ec_e0c28d02aecdd884abb40e5f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Dunkin'",
      "poi_type": "Restaurants",
      "poi_address": "11612 City Hall Promenade, Miramar, FL 33025, USA",
      "poi_short_description": "Long-running chain serving signature breakfast items & a variety of coffee drinks.",
      "poi_long_description": "Long-running chain serving signature breakfast items & a variety of coffee drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-8d4a-70e8-869b-6a0dd94b33db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-8d4a-70e8-869b-6a0dd94b33db",
        "storage_key": "property/5174219562287104/019f1502-8d4a-70e8-869b-6a0dd94b33db.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://locations.dunkindonuts.com/en/fl/miramar/11612-city-hall-promenade/351844?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=351844&y_source=1_MTIxMTQyNzUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6098871222167054615&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dunkin",
      "poi_latitude": "25.9857121",
      "poi_longitude": "-80.2994849",
      "poi_miles_from_property": "358 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 954-441-6655",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1503-0a5e-75dd-9a32-76307496b685.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0a5e-75dd-9a32-76307496b685",
        "storage_key": "property/5174219562287104/019f1503-0a5e-75dd-9a32-76307496b685.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ-aY0pMKl2YgRF6keOBCLo1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_9ccd92a2f1bad173dabbcf4b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Juici Patties",
      "poi_type": "Restaurants",
      "poi_address": "11735 City Hall Promenade, Miramar, FL 33025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-93d3-7178-92d6-8ae46616ff4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-93d3-7178-92d6-8ae46616ff4b",
        "storage_key": "property/5174219562287104/019f1502-93d3-7178-92d6-8ae46616ff4b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://juicipattiesusa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4065377620816770203&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "juici-patties",
      "poi_latitude": "25.9861026",
      "poi_longitude": "-80.2996208",
      "poi_miles_from_property": "210 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 954-335-7379",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a930-758e-b81b-9abbdfcf7e6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a930-758e-b81b-9abbdfcf7e6b",
        "storage_key": "property/5174219562287104/019f1500-a930-758e-b81b-9abbdfcf7e6b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4V_oVACl2YgRmzSbJmgfazg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_7a8f9dd23688f409e5ed7c96",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "La Famiglia Italian Restaurant & Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "11655 Red Rd, Miramar, FL 33025, USA",
      "poi_short_description": "A large menu of Italian mainstays such as pizza & housemade pastas offered in family-friendly digs.",
      "poi_long_description": "A large menu of Italian mainstays such as pizza & housemade pastas offered in family-friendly digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-8dec-772e-bf08-3b6af5599645.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-8dec-772e-bf08-3b6af5599645",
        "storage_key": "property/5174219562287104/019f1502-8dec-772e-bf08-3b6af5599645.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "http://www.lafamigliamiramar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6797367153957674997&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-famiglia-italian-restaurant--pizzeria",
      "poi_latitude": "25.985102",
      "poi_longitude": "-80.3000167",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 954-862-7499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a930-758e-b81b-9abbdfcf7e6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a930-758e-b81b-9abbdfcf7e6b",
        "storage_key": "property/5174219562287104/019f1500-a930-758e-b81b-9abbdfcf7e6b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLcj77sKl2YgR9R-Om2kZVV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_a147d818ed463841440a3458",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Cucina Moderna",
      "poi_type": "Restaurants",
      "poi_address": "11225 Miramar Pkwy Ste 260, Miramar, FL 33025, USA",
      "poi_short_description": "Pizza and brunch eatery with a bar for Italian classics (plus live DJ sets).",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-8e02-76d8-b367-419a9fabb2ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-8e02-76d8-b367-419a9fabb2ad",
        "storage_key": "property/5174219562287104/019f1502-8e02-76d8-b367-419a9fabb2ad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cucinamodernafl.com/miramar-menu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11115700597776508939&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cucina-moderna",
      "poi_latitude": "25.9798087",
      "poi_longitude": "-80.2961514",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 954-530-5244",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a930-758e-b81b-9abbdfcf7e6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a930-758e-b81b-9abbdfcf7e6b",
        "storage_key": "property/5174219562287104/019f1500-a930-758e-b81b-9abbdfcf7e6b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJi81WzOul2YgRC-gQ2MzmQpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_199f2aead87aaa656c6ee43b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Flanigan's Seafood Bar and Grill",
      "poi_type": "Restaurants",
      "poi_address": "11225 Miramar Pkwy, Miramar, FL 33025, USA",
      "poi_short_description": "American eats & seafood are served at this local chain restaurant & sports bar with plenty of TVs.",
      "poi_long_description": "American eats & seafood are served at this local chain restaurant & sports bar with plenty of TVs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-4f5f-760e-9f08-33941b94f6f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-4f5f-760e-9f08-33941b94f6f5",
        "storage_key": "property/5174219562287104/019f1500-4f5f-760e-9f08-33941b94f6f5.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.flanigans.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11885834905819119257&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flanigans-seafood-bar-and-grill",
      "poi_latitude": "25.979423",
      "poi_longitude": "-80.296201",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 954-251-4734",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a94a-756d-9fc1-b9df7f8687bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a94a-756d-9fc1-b9df7f8687bc",
        "storage_key": "property/5174219562287104/019f1500-a94a-756d-9fc1-b9df7f8687bc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz1BFHEOl2YgRmX5JfN_38qQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_abb5b23806f18ab922f06147",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Silver Spoon Thai & Sushi",
      "poi_type": "Restaurants",
      "poi_address": "2929 SW 160th Ave, Miramar, FL 33027, USA",
      "poi_short_description": "Casual eatery serving Japanese faves, including lots of sushi selections, & traditional Thai meals.",
      "poi_long_description": "Casual eatery serving Japanese faves, including lots of sushi selections, & traditional Thai meals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-91cd-70a8-98f9-66b879e278dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-91cd-70a8-98f9-66b879e278dc",
        "storage_key": "property/5174219562287104/019f1502-91cd-70a8-98f9-66b879e278dc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://silverspoon-miramar.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=2771398055312875231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "silver-spoon-thai--sushi",
      "poi_latitude": "25.9814199",
      "poi_longitude": "-80.3591273",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 954-431-8868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a930-758e-b81b-9abbdfcf7e6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a930-758e-b81b-9abbdfcf7e6b",
        "storage_key": "property/5174219562287104/019f1500-a930-758e-b81b-9abbdfcf7e6b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBxmccQyk2YgR394hCtn7dSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "ec_dbc1ab156afeb23ff45ff334",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Cleveland’s Old Fashion Ice Cream",
      "poi_type": "Restaurants",
      "poi_address": "6933 Miramar Pkwy, Miramar, FL 33023, USA",
      "poi_short_description": "Casual ice-cream shop specializing in homemade flavors plus a vegan selection.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-929f-7350-ba4f-08c01cc9a43e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-929f-7350-ba4f-08c01cc9a43e",
        "storage_key": "property/5174219562287104/019f1502-929f-7350-ba4f-08c01cc9a43e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://papacleve.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4547886436080493083&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clevelands-old-fashion-ice-cream",
      "poi_latitude": "25.9827397",
      "poi_longitude": "-80.2264801",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 754-888-9152",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a930-758e-b81b-9abbdfcf7e6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a930-758e-b81b-9abbdfcf7e6b",
        "storage_key": "property/5174219562287104/019f1500-a930-758e-b81b-9abbdfcf7e6b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8-NiyZmv2YgRGyJlLZ5WHT8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_cream_shop"
    },
    {
      "id": "ec_bd1f6e33a49d00ba49441e8d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Chez Guyto Take Out Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "6520 Pembroke Rd, Miramar, FL 33023, USA",
      "poi_short_description": "Homestyle carry-out Haitian grub, plus breakfast food, served up in a narrow, cafeteria-style joint.",
      "poi_long_description": "Homestyle carry-out Haitian grub, plus breakfast food, served up in a narrow, cafeteria-style joint.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-931c-76c7-86a8-0c83e829332c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-931c-76c7-86a8-0c83e829332c",
        "storage_key": "property/5174219562287104/019f1502-931c-76c7-86a8-0c83e829332c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chezguyto.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4923965588119810715&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chez-guyto-take-out-restaurant",
      "poi_latitude": "25.9951248",
      "poi_longitude": "-80.21774289999999",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 954-963-6139",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a930-758e-b81b-9abbdfcf7e6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a930-758e-b81b-9abbdfcf7e6b",
        "storage_key": "property/5174219562287104/019f1500-a930-758e-b81b-9abbdfcf7e6b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL2y1BDOp2YgRm_IgNp1wVUQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_9d8e33cec9d9a4ef7777d002",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "La Carreta Miramar",
      "poi_type": "Restaurants",
      "poi_address": "14791 Miramar Pkwy, Miramar, FL 33027, USA",
      "poi_short_description": "Easygoing operation offering homestyle Cuban classics like ropa vieja & picadillo.",
      "poi_long_description": "Easygoing operation offering homestyle Cuban classics like ropa vieja & picadillo.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-9ceb-768b-9ef5-009cc563708c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-9ceb-768b-9ef5-009cc563708c",
        "storage_key": "property/5174219562287104/019f1502-9ceb-768b-9ef5-009cc563708c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://lacarreta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1122712430062170600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-carreta-miramar",
      "poi_latitude": "25.9792881",
      "poi_longitude": "-80.34299469999999",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 954-437-3602",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a930-758e-b81b-9abbdfcf7e6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a930-758e-b81b-9abbdfcf7e6b",
        "storage_key": "property/5174219562287104/019f1500-a930-758e-b81b-9abbdfcf7e6b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyd5S5j-k2YgR6HHFugGtlA8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cuban_restaurant"
    },
    {
      "id": "ec_af0338ff4de51f79c8791145",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Benihana - Miramar",
      "poi_type": "Restaurants",
      "poi_address": "3261 SW 160th Ave, Miramar, FL 33027, USA",
      "poi_short_description": "Hibachi chain serving Japanese dishes grilled tableside by theatrical chefs.",
      "poi_long_description": "Hibachi chain serving Japanese dishes grilled tableside by theatrical chefs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-99d8-73a1-aa56-64282f6ddbab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-99d8-73a1-aa56-64282f6ddbab",
        "storage_key": "property/5174219562287104/019f1502-99d8-73a1-aa56-64282f6ddbab.webp",
        "width": 695,
        "height": 388
      },
      "poi_business_url": "https://www.benihana.com/locations/miramar/?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=6443890916661307122&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "benihana---miramar",
      "poi_latitude": "25.9805656",
      "poi_longitude": "-80.3545953",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 954-342-2892",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a930-758e-b81b-9abbdfcf7e6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a930-758e-b81b-9abbdfcf7e6b",
        "storage_key": "property/5174219562287104/019f1500-a930-758e-b81b-9abbdfcf7e6b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX42RYQ2k2YgR8qb2wqVMbVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "ec_790bf510e2cdcd11934a2983",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Pita Shop",
      "poi_type": "Restaurants",
      "poi_address": "3448 Red Rd, Miramar, FL 33025, USA",
      "poi_short_description": "Basic counter serve preparing halal Middle Eastern sandwiches, kebabs & other traditional bites.",
      "poi_long_description": "Basic counter serve preparing halal Middle Eastern sandwiches, kebabs & other traditional bites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-9d8c-7428-9a99-31b034fb172b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-9d8c-7428-9a99-31b034fb172b",
        "storage_key": "property/5174219562287104/019f1502-9d8c-7428-9a99-31b034fb172b.webp",
        "width": 1103,
        "height": 1280
      },
      "poi_business_url": "https://pitashopflorida.com/pitashopredrd?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=4234829445385772970&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pita-shop",
      "poi_latitude": "25.9772058",
      "poi_longitude": "-80.2958281",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 954-391-7821",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a930-758e-b81b-9abbdfcf7e6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a930-758e-b81b-9abbdfcf7e6b",
        "storage_key": "property/5174219562287104/019f1500-a930-758e-b81b-9abbdfcf7e6b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNzdGBOul2YgRql-ViPEixTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "ec_0de1a74753b6d87213730b22",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Sarpino's Pizzeria Miramar",
      "poi_type": "Restaurants",
      "poi_address": "12136 Miramar Pkwy, Miramar, FL 33025, USA",
      "poi_short_description": "Relaxed eatery featuring an extensive menu of fresh New York-style pizza pies with a variety of toppings.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-9ff5-727d-b9a3-d30f7d4abbab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-9ff5-727d-b9a3-d30f7d4abbab",
        "storage_key": "property/5174219562287104/019f1502-9ff5-727d-b9a3-d30f7d4abbab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gosarpinos.com/pizza-delivery/sarpinos-miramar?utm_source=Google&utm_medium=Organic&utm_campaign=LocalSEO",
      "poi_directions_map_url": "https://maps.google.com/?cid=1854455670138005675&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sarpinos-pizzeria-miramar",
      "poi_latitude": "25.9773",
      "poi_longitude": "-80.3077",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 954-441-3838",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a991-709b-aeff-7efd6b6071ab",
        "storage_key": "property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTS7ssPul2YgRq-hITptZvBk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_delivery"
    },
    {
      "id": "ec_ef893ebe753b27369a2fe0d0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Publix Super Market at Miramar Commons",
      "poi_type": "Shopping & Retail",
      "poi_address": "11000 Pembroke Rd, Miramar, FL 33025, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-9d3c-73cc-a8af-8c2c23584a30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-9d3c-73cc-a8af-8c2c23584a30",
        "storage_key": "property/5174219562287104/019f1502-9d3c-73cc-a8af-8c2c23584a30.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=652&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=3637461355832163797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-miramar-commons",
      "poi_latitude": "25.9913793",
      "poi_longitude": "-80.2944272",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 954-441-7918",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a98f-77ac-ba2d-0095bd5ff59c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a98f-77ac-ba2d-0095bd5ff59c",
        "storage_key": "property/5174219562287104/019f1500-a98f-77ac-ba2d-0095bd5ff59c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy9u1sOal2YgR1T2WvtTbejI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_3cdcf14f7225e9573bbee465",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "8901 Miramar Pkwy, Miramar, FL 33025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-9d3f-765b-be7c-95c0356d3320.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-9d3f-765b-be7c-95c0356d3320",
        "storage_key": "property/5174219562287104/019f1502-9d3f-765b-be7c-95c0356d3320.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/miramar-fl-pharmacies/8901-miramar-pkwy-miramar-fl-33025/storeid=5182?WT.mc_id=LS_GOOGLE_RX_5182",
      "poi_directions_map_url": "https://maps.google.com/?cid=9407199174474210195&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "25.981603",
      "poi_longitude": "-80.263717",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 954-442-3914",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1503-0a53-7189-88f9-1dc7a478e140.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0a53-7189-88f9-1dc7a478e140",
        "storage_key": "property/5174219562287104/019f1503-0a53-7189-88f9-1dc7a478e140.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYyJYHEWv2YgRkxvixc4VjYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_527174a765efe5cdb6298853",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "8001 Miramar Pkwy, Miramar, FL 33025, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-a1da-7411-a16b-c30741c85411.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-a1da-7411-a16b-c30741c85411",
        "storage_key": "property/5174219562287104/019f1502-a1da-7411-a16b-c30741c85411.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-8001+miramar+pkwy-miramar-fl-33025/id=6011",
      "poi_directions_map_url": "https://maps.google.com/?cid=14772092818780064297&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "25.9824394",
      "poi_longitude": "-80.24790430000002",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 954-437-9552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a991-709b-aeff-7efd6b6071ab",
        "storage_key": "property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQaxgETqv2YgRKQp8HCcEAc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_14c041b887237e460a8a2d44",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "12255 Miramar Pkwy, Miramar, FL 33025, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-a314-761b-88cb-a4a0b397e662.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-a314-761b-88cb-a4a0b397e662",
        "storage_key": "property/5174219562287104/019f1502-a314-761b-88cb-a4a0b397e662.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://info.aldi.us/stores/l/fl/miramar/12255-miramar-parkway/fa30",
      "poi_directions_map_url": "https://maps.google.com/?cid=6292706270971132865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "25.979368",
      "poi_longitude": "-80.309354",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a98f-77ac-ba2d-0095bd5ff59c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a98f-77ac-ba2d-0095bd5ff59c",
        "storage_key": "property/5174219562287104/019f1500-a98f-77ac-ba2d-0095bd5ff59c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo3eCYjal2YgRwXsbZQMvVFc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_5702d954115e33a99faeb085",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "12216 Miramar Pkwy, Miramar, FL 33025, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-a4b3-71db-b1f5-7d7de88fcc59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-a4b3-71db-b1f5-7d7de88fcc59",
        "storage_key": "property/5174219562287104/019f1502-a4b3-71db-b1f5-7d7de88fcc59.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sprouts.com/store/fl/miramar/miramar/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7170421663380336493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "25.976738",
      "poi_longitude": "-80.30987499999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 754-799-8177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a98f-77ac-ba2d-0095bd5ff59c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a98f-77ac-ba2d-0095bd5ff59c",
        "storage_key": "property/5174219562287104/019f1500-a98f-77ac-ba2d-0095bd5ff59c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-awW_dil2YgRbe-MJ4N0gmM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_a84d95d5a7ee7a6223dcff75",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "1800 S University Dr, Miramar, FL 33025, USA",
      "poi_short_description": "Big-brand department store stocked with groceries, home goods and clothing, plus an on-site bakery.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-a55d-77c8-9e9e-4660f8b5cd49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-a55d-77c8-9e9e-4660f8b5cd49",
        "storage_key": "property/5174219562287104/019f1502-a55d-77c8-9e9e-4660f8b5cd49.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1511-miramar-fl/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17241669549679318251&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "25.9936138",
      "poi_longitude": "-80.2499768",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 954-433-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a94b-74e9-b4a6-dfafe7b5393a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a94b-74e9-b4a6-dfafe7b5393a",
        "storage_key": "property/5174219562287104/019f1500-a94b-74e9-b4a6-dfafe7b5393a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJiVDkjzSv2YgR6xRO6xq3Ru8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_baa19e995ce2f493a4d516b7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "1900 S University Dr, Miramar, FL 33025, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-a16d-76d7-a01a-fe07a0520969.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-a16d-76d7-a01a-fe07a0520969",
        "storage_key": "property/5174219562287104/019f1502-a16d-76d7-a01a-fe07a0520969.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/8173-miramar-fl",
      "poi_directions_map_url": "https://maps.google.com/?cid=4887515826541916770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "25.9921162",
      "poi_longitude": "-80.2498866",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 954-433-8867",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a94b-74e9-b4a6-dfafe7b5393a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a94b-74e9-b4a6-dfafe7b5393a",
        "storage_key": "property/5174219562287104/019f1500-a94b-74e9-b4a6-dfafe7b5393a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZQ_1czOv2YgRYnIhw7_x00M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_6f45a7ad5e3978b211e11a5e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "12200 Miramar Pkwy, Miramar, FL 33025, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-a762-70df-b8ff-dba01fd4a1a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-a762-70df-b8ff-dba01fd4a1a2",
        "storage_key": "property/5174219562287104/019f1502-a762-70df-b8ff-dba01fd4a1a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kohls.com/stores/fl/miramar-1248.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10955781125404065784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kohls",
      "poi_latitude": "25.9765547",
      "poi_longitude": "-80.30894959999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 954-431-1560",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a94b-74e9-b4a6-dfafe7b5393a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a94b-74e9-b4a6-dfafe7b5393a",
        "storage_key": "property/5174219562287104/019f1500-a94b-74e9-b4a6-dfafe7b5393a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6yTv6sel2YgR-H-jKOPACpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_3b218c26c9ce5f108f176a27",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Miramar Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "12100 Miramar Pkwy, Miramar, FL 33025, USA",
      "poi_short_description": "Polished, Mediterranean-style retail center hosting a mix of small shops, eateries & services.",
      "poi_long_description": "Polished, Mediterranean-style retail center hosting a mix of small shops, eateries & services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-a761-765f-9e8f-7bc19a2a0673.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-a761-765f-9e8f-7bc19a2a0673",
        "storage_key": "property/5174219562287104/019f1502-a761-765f-9e8f-7bc19a2a0673.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "http://kiterealty.com/properties/miramar-square",
      "poi_directions_map_url": "https://maps.google.com/?cid=12617523070612286045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miramar-square",
      "poi_latitude": "25.9774125",
      "poi_longitude": "-80.3077201",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 317-578-5153",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a94b-74e9-b4a6-dfafe7b5393a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a94b-74e9-b4a6-dfafe7b5393a",
        "storage_key": "property/5174219562287104/019f1500-a94b-74e9-b4a6-dfafe7b5393a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ097Hw8el2YgRXSok2WFyGq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_defc04933b3b0bc7e2b33f86",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Sea Castle Elementary School",
      "poi_type": "Education",
      "poi_address": "9600 Miramar Blvd, Miramar, FL 33025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.browardschools.com/seacastle",
      "poi_directions_map_url": "https://maps.google.com/?cid=17534706410988194370&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sea-castle-elementary-school",
      "poi_latitude": "25.9871331",
      "poi_longitude": "-80.27423859999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 754-323-7250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a94c-723b-93c6-967d0a270b72",
        "storage_key": "property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH6WgCVev2YgRQkq385PKV_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_b2d2341f2e0ac5117c507343",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "New Renaissance Middle School",
      "poi_type": "Education",
      "poi_address": "10701 Miramar Blvd, Miramar, FL 33025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.browardschools.com/newrenaissance",
      "poi_directions_map_url": "https://maps.google.com/?cid=9583944046028541772&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-renaissance-middle-school",
      "poi_latitude": "25.9883631",
      "poi_longitude": "-80.2887502",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 754-323-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a94c-723b-93c6-967d0a270b72",
        "storage_key": "property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa5Y-MOWl2YgRTE_A-lQCAYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_2e30701e2ba9b9cb0b6532a6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Miramar High School",
      "poi_type": "Education",
      "poi_address": "3601 SW 89th Ave, Miramar, FL 33025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-aae0-743b-b91e-cbc08739aff1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-aae0-743b-b91e-cbc08739aff1",
        "storage_key": "property/5174219562287104/019f1502-aae0-743b-b91e-cbc08739aff1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.browardschools.com/miramarhigh",
      "poi_directions_map_url": "https://maps.google.com/?cid=2253208698572310580&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miramar-high-school",
      "poi_latitude": "25.976165",
      "poi_longitude": "-80.2621899",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 754-323-1350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a94c-723b-93c6-967d0a270b72",
        "storage_key": "property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5Znr-2ev2YgRNAg5k18BRR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_bb9c2eb5f42a06718eadd899",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Precious Years Christian Learning Center",
      "poi_type": "Education",
      "poi_address": "11400 Miramar Pkwy, Miramar, FL 33025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-a81c-7429-99cd-3d286c52fa4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-a81c-7429-99cd-3d286c52fa4a",
        "storage_key": "property/5174219562287104/019f1502-a81c-7429-99cd-3d286c52fa4a.webp",
        "width": 1280,
        "height": 824
      },
      "poi_business_url": "http://www.preciousyearsclc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12963895012899347531&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "precious-years-christian-learning-center",
      "poi_latitude": "25.9781618",
      "poi_longitude": "-80.29811339999999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 954-450-3773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a94c-723b-93c6-967d0a270b72",
        "storage_key": "property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeRoRZOql2YgRS9xSHdQB6bM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_3eb9ccaeb9b2d042ebd83012",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "La Petite Academy of Miramar",
      "poi_type": "Education",
      "poi_address": "2610 S Douglas Rd, Miramar, FL 33025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-a93e-73c9-9234-229515e39cdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-a93e-73c9-9234-229515e39cdf",
        "storage_key": "property/5174219562287104/019f1502-a93e-73c9-9234-229515e39cdf.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://www.lapetite.com/your-local-school/miramar-fl-7522/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=7522",
      "poi_directions_map_url": "https://maps.google.com/?cid=18281500387740776760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-petite-academy-of-miramar",
      "poi_latitude": "25.9853484",
      "poi_longitude": "-80.2636304",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 877-271-6466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a94c-723b-93c6-967d0a270b72",
        "storage_key": "property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYxM6l0-v2YgROHl0PL7vtP0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_e77b5eab56b987a8e4a6282b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Miramarvels Early Childhood Academy",
      "poi_type": "Education",
      "poi_address": "2801 SW 186th Ave, Miramar, FL 33029, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.miramarfl.gov/Departments/Social-Services/Miramarvels-Early-Childhood-Academy",
      "poi_directions_map_url": "https://maps.google.com/?cid=4260885596233505610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miramarvels-early-childhood-academy",
      "poi_latitude": "25.9832914",
      "poi_longitude": "-80.3937749",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 954-883-5230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a94c-723b-93c6-967d0a270b72",
        "storage_key": "property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ85RMcz-j2YgRSpsT6N-0ITs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_7eaf3e25b15482ba4c941a5f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Coconut Palm Elementary School",
      "poi_type": "Education",
      "poi_address": "13601 Monarch Lakes Blvd, Miramar, FL 33027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.browardschools.com/coconutpalm",
      "poi_directions_map_url": "https://maps.google.com/?cid=3984771762427598422&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coconut-palm-elementary-school",
      "poi_latitude": "25.9860438",
      "poi_longitude": "-80.32885809999999",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 754-323-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a94c-723b-93c6-967d0a270b72",
        "storage_key": "property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuQ2KpjGk2YgRVhaBQs7ATDc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_1bae5cd33e59e10d3bc6ecae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Small World Montessori School of Miramar",
      "poi_type": "Education",
      "poi_address": "18461 Miramar Pkwy, Miramar, FL 33029, USA",
      "poi_short_description": "Montessori-based education center with warm teachers and a nutritional menu.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-abad-75de-8f74-b280c98dc7cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-abad-75de-8f74-b280c98dc7cc",
        "storage_key": "property/5174219562287104/019f1502-abad-75de-8f74-b280c98dc7cc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://swmontessori.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11203482672982943310&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "small-world-montessori-school-of-miramar",
      "poi_latitude": "25.97996",
      "poi_longitude": "-80.39411969999999",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 954-544-2915",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a94c-723b-93c6-967d0a270b72",
        "storage_key": "property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJdSsRr-j2YgRTmZk6iHEeps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_1093cb8d5f2536e18eb094b9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Life Learning Preschool Academy",
      "poi_type": "Education",
      "poi_address": "1810 Alcazar Dr, Miramar, FL 33023, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-ac1a-746d-aceb-8bc6b4a2abcb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-ac1a-746d-aceb-8bc6b4a2abcb",
        "storage_key": "property/5174219562287104/019f1502-ac1a-746d-aceb-8bc6b4a2abcb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lifelearningacademy.org/?utm_source=google&utm_medium=gmb&utm_campaign=ddm_local_seo",
      "poi_directions_map_url": "https://maps.google.com/?cid=7821308714071918059&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "life-learning-preschool-academy",
      "poi_latitude": "25.9940708",
      "poi_longitude": "-80.22941689999999",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 954-213-1355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a94c-723b-93c6-967d0a270b72",
        "storage_key": "property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ6UAy8mp2YgR64XsHNbeimw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_b753ab397140e4975624d46a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Broward College-South Campus",
      "poi_type": "Education",
      "poi_address": "7200 Pines Blvd, Pembroke Pines, FL 33024, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-5a3c-7305-aeee-24fa0d342b03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-5a3c-7305-aeee-24fa0d342b03",
        "storage_key": "property/5174219562287104/019f1500-5a3c-7305-aeee-24fa0d342b03.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.broward.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5386749430528690973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broward-college-south-campus",
      "poi_latitude": "26.0065507",
      "poi_longitude": "-80.2343505",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 954-201-7350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a94c-723b-93c6-967d0a270b72",
        "storage_key": "property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ68TX1Nmo2YgRHUuzHBGUwUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_4731a78fae19381379f2975e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Miramar Cultural Center",
      "poi_type": "Entertainment",
      "poi_address": "2400 Civic Center Pl, Miramar, FL 33025, USA",
      "poi_short_description": "Centered around an 800-seat theater, this complex also offers 2 art galleries & a botanical garden.",
      "poi_long_description": "Centered around an 800-seat theater, this complex also offers 2 art galleries & a botanical garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-ab9e-7580-979d-60476b42cecc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-ab9e-7580-979d-60476b42cecc",
        "storage_key": "property/5174219562287104/019f1502-ab9e-7580-979d-60476b42cecc.webp",
        "width": 600,
        "height": 412
      },
      "poi_business_url": "https://miramarculturalcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2488703510774905866&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miramar-cultural-center",
      "poi_latitude": "25.9861562",
      "poi_longitude": "-80.301495",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 954-602-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a991-709b-aeff-7efd6b6071ab",
        "storage_key": "property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0UrM3sKl2YgRCnwBR6imiSI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cultural_center"
    },
    {
      "id": "ec_fd21309a6821274955f4c58a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Miramar Regional Park Amphitheater",
      "poi_type": "Entertainment",
      "poi_address": "16801 Miramar Pkwy, Miramar, FL 33027, USA",
      "poi_short_description": "Casual amphitheater where live shows and festivals take place, plus some events.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-af9f-7502-881e-857b6f3ee360.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-af9f-7502-881e-857b6f3ee360",
        "storage_key": "property/5174219562287104/019f1502-af9f-7502-881e-857b6f3ee360.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://miramaramp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16180852268219529466&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miramar-regional-park-amphitheater",
      "poi_latitude": "25.9856879",
      "poi_longitude": "-80.3722322",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 954-883-6948",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a991-709b-aeff-7efd6b6071ab",
        "storage_key": "property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMUDVEPSj2YgR-nhMemjvjeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "ec_8ad8e1d4b1dbf641559bc852",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "AMC Pembroke Lakes 9",
      "poi_type": "Entertainment",
      "poi_address": "12085 Pines Blvd, Pembroke Pines, FL 33026, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-b008-73bc-ac91-1c5fcf48ec55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-b008-73bc-ac91-1c5fcf48ec55",
        "storage_key": "property/5174219562287104/019f1502-b008-73bc-ac91-1c5fcf48ec55.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/miami-ft-lauderdale/amc-pembroke-lake-9?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5935170145340037418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-pembroke-lakes-9",
      "poi_latitude": "26.0104948",
      "poi_longitude": "-80.30794139999999",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 754-210-2148",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1503-0a80-7578-b7c3-646a9b66bd9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0a80-7578-b7c3-646a9b66bd9e",
        "storage_key": "property/5174219562287104/019f1503-0a80-7578-b7c3-646a9b66bd9e.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJc4OMWHCm2YgRKhl_Is31XVI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_6caba025ec7c72e80a12dad3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Round1 Bowling & Arcade - Pembroke Pines",
      "poi_type": "Entertainment",
      "poi_address": "12055 Pines Blvd, Pembroke Pines, FL 33026, USA",
      "poi_short_description": "Family entertainment center offering a bowling alley, karaoke, arcade games, batting cages, billiards, and more.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-b0cc-71bf-9e0e-81e4c8e21c14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-b0cc-71bf-9e0e-81e4c8e21c14",
        "storage_key": "property/5174219562287104/019f1502-b0cc-71bf-9e0e-81e4c8e21c14.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://round1usa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=214401523857602654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "round1-bowling--arcade---pembroke-pines",
      "poi_latitude": "26.0104232",
      "poi_longitude": "-80.30706119999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 754-216-7404",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a991-709b-aeff-7efd6b6071ab",
        "storage_key": "property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp9IZttan2YgRXrjVzAy1-QI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_c27bab4fba01c3676e58354c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "C.B. Smith Park",
      "poi_type": "Entertainment",
      "poi_address": "900 N Flamingo Rd, Pembroke Pines, FL 33028, USA",
      "poi_short_description": "299-acre green space offering a water park & camping, plus areas for a wide variety of sports.",
      "poi_long_description": "299-acre green space offering a water park & camping, plus areas for a wide variety of sports.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-b132-7566-92c0-c2bce68daed0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-b132-7566-92c0-c2bce68daed0",
        "storage_key": "property/5174219562287104/019f1502-b132-7566-92c0-c2bce68daed0.webp",
        "width": 550,
        "height": 412
      },
      "poi_business_url": "http://www.broward.org/Parks/Pages/Park.aspx?=5",
      "poi_directions_map_url": "https://maps.google.com/?cid=12003765789026073852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cb-smith-park",
      "poi_latitude": "26.0160053",
      "poi_longitude": "-80.3158971",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 954-357-5170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a9b0-7167-9862-e3362e729f7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a9b0-7167-9862-e3362e729f7b",
        "storage_key": "property/5174219562287104/019f1500-a9b0-7167-9862-e3362e729f7b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJi-gPjmOm2YgR_Lzi7WLxlaY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_e07b73fbc2f122074232f7ad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Pines Ice Arena",
      "poi_type": "Entertainment",
      "poi_address": "12425 Taft St, Pembroke Pines, FL 33028, USA",
      "poi_short_description": "Rink with public skating plus private lessons, hockey leagues, birthday parties & pro shop.",
      "poi_long_description": "Rink with public skating plus private lessons, hockey leagues, birthday parties & pro shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-be6f-7722-a886-d356a3e43b5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-be6f-7722-a886-d356a3e43b5f",
        "storage_key": "property/5174219562287104/019f1502-be6f-7722-a886-d356a3e43b5f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pinesice.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13144388905702125700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pines-ice-arena",
      "poi_latitude": "26.0229015",
      "poi_longitude": "-80.3140564",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 954-704-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a991-709b-aeff-7efd6b6071ab",
        "storage_key": "property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJYpoiV2m2YgRhPD1WRFAarY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_skating_rink"
    },
    {
      "id": "ec_6e75324af7989faa700ca517",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Young At Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "8000 W Broward Blvd Ste 1208, Plantation, FL 33388, USA",
      "poi_short_description": "Spacious, modern facility offering classes, field trips, day camps, interactive workshops & cafe.",
      "poi_long_description": "Spacious, modern facility offering classes, field trips, day camps, interactive workshops & cafe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-b416-7200-89fe-c1af81ad0b2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-b416-7200-89fe-c1af81ad0b2f",
        "storage_key": "property/5174219562287104/019f1502-b416-7200-89fe-c1af81ad0b2f.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.youngatartmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5684102637923064386&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "young-at-art-museum",
      "poi_latitude": "26.1186544",
      "poi_longitude": "-80.2546332",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 17 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 954-424-0085",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a99c-7112-a91b-4c35778a37f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a99c-7112-a91b-4c35778a37f3",
        "storage_key": "property/5174219562287104/019f1500-a99c-7112-a91b-4c35778a37f3.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJf5zE6CQJ2YgRQtpDyDv94U4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_54503aadd3613fb20e9d6e29",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Seminole Hard Rock Hotel & Casino",
      "poi_type": "Entertainment",
      "poi_address": "1 Seminole Way, Davie, FL 33314, USA",
      "poi_short_description": "Lavish hotel with a rock ’n’ roll theme, offering dining & bars, plus live music, a casino & pools.",
      "poi_long_description": "Lavish hotel with a rock ’n’ roll theme, offering dining & bars, plus live music, a casino & pools.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-b5e7-718c-9a60-5ebc8a2a7f85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-b5e7-718c-9a60-5ebc8a2a7f85",
        "storage_key": "property/5174219562287104/019f1502-b5e7-718c-9a60-5ebc8a2a7f85.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://casino.hardrock.com/hollywood?utm_campaign=shrss_casino_hard-rock-hotel-and-casino-hollywood_websitelisting&utm_medium=referral&utm_source=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=4332899259427062826&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seminole-hard-rock-hotel--casino",
      "poi_latitude": "26.0525048",
      "poi_longitude": "-80.20976809999999",
      "poi_miles_from_property": "9.2 mi",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 866-502-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1503-0a84-7149-910a-6572c37c7983.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0a84-7149-910a-6572c37c7983",
        "storage_key": "property/5174219562287104/019f1503-0a84-7149-910a-6572c37c7983.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJ32l5iEzPwogRKgS0deuMITw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "resort_hotel"
    },
    {
      "id": "ec_17d0c76c3b7b74315116d3b5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Miami Stadium",
      "poi_type": "Entertainment",
      "poi_address": "347 Don Shula Dr Suite 102, Miami Gardens, FL 33056, USA",
      "poi_short_description": "Stadium hosting the Miami Dolphins, Super Bowls, concerts & more, with eateries & concessions.",
      "poi_long_description": "Stadium hosting the Miami Dolphins, Super Bowls, concerts & more, with eateries & concessions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-68cf-7310-82cd-744c47ec0206.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-68cf-7310-82cd-744c47ec0206",
        "storage_key": "property/5174219562287104/019f1500-68cf-7310-82cd-744c47ec0206.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://hardrockstadium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6347227278942665179&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miami-stadium",
      "poi_latitude": "25.957863",
      "poi_longitude": "-80.2389542",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 305-943-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a99a-750d-a33e-c5bf9619531b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a99a-750d-a33e-c5bf9619531b",
        "storage_key": "property/5174219562287104/019f1500-a99a-750d-a33e-c5bf9619531b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqfO1lwSv2YgR2_kLxpThFVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "ec_bea395b419b128e5cfa497fe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Xtreme Action Park",
      "poi_type": "Entertainment",
      "poi_address": "5300 Powerline Rd, Fort Lauderdale, FL 33309, USA",
      "poi_short_description": "Complex with a half-mile asphalt go-kart track, bowling lanes, an indoor ropes course & a bar.",
      "poi_long_description": "Complex with a half-mile asphalt go-kart track, bowling lanes, an indoor ropes course & a bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-b777-7409-a52f-8ee1c929f24d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-b777-7409-a52f-8ee1c929f24d",
        "storage_key": "property/5174219562287104/019f1502-b777-7409-a52f-8ee1c929f24d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://xtremeactionpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14883603637275764570&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "xtreme-action-park",
      "poi_latitude": "26.1915924",
      "poi_longitude": "-80.1536955",
      "poi_miles_from_property": "22.1 mi",
      "poi_walking_minutes": "8 hours 12 mins",
      "poi_biking_minutes": "2 hours 4 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 954-491-6265",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a991-709b-aeff-7efd6b6071ab",
        "storage_key": "property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhdEC7MUD2YgRWqeIwaYujc4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_8ae2c7804d8200a2767b8e04",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Memorial Hospital Miramar",
      "poi_type": "Health and Wellness",
      "poi_address": "1901 SW 172nd Ave, Miramar, FL 33029, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-8028-77d6-93b6-8f91fbe3d2cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-8028-77d6-93b6-8f91fbe3d2cc",
        "storage_key": "property/5174219562287104/019f1500-8028-77d6-93b6-8f91fbe3d2cc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.mhs.net/locations/memorial-hospital-miramar",
      "poi_directions_map_url": "https://maps.google.com/?cid=18168369644712303855&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hospital-miramar",
      "poi_latitude": "25.9909485",
      "poi_longitude": "-80.3732483",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 954-538-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a996-7267-ade6-14a6342b9fbf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a996-7267-ade6-14a6342b9fbf",
        "storage_key": "property/5174219562287104/019f1500-a996-7267-ade6-14a6342b9fbf.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1-bI8_Gj2YgR7xwRhe4DI_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_89b3bf0322c49c6e0561e838",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Memorial Pembroke 24/7 Care Center",
      "poi_type": "Health and Wellness",
      "poi_address": "801 S Douglas Rd, Pembroke Pines, FL 33025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-c0c1-7268-bdae-f264879f7a3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-c0c1-7268-bdae-f264879f7a3f",
        "storage_key": "property/5174219562287104/019f1502-c0c1-7268-bdae-f264879f7a3f.webp",
        "width": 800,
        "height": 570
      },
      "poi_business_url": "https://www.mhs.net/locations/memorial-pembroke/24-7-care",
      "poi_directions_map_url": "https://maps.google.com/?cid=7706389381743510593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-pembroke-247-care-center",
      "poi_latitude": "26.0026708",
      "poi_longitude": "-80.2621322",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 954-276-6501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a991-709b-aeff-7efd6b6071ab",
        "storage_key": "property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPwqHmrGo2YgRQQSq_0-Y8mo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_8d41a81d7c3c3f04605d38b4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Jas Medical Management",
      "poi_type": "Health and Wellness",
      "poi_address": "6151 Miramar Pkwy #104, Miramar, FL 33023, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-c11d-767b-9aaf-dbe874082841.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-c11d-767b-9aaf-dbe874082841",
        "storage_key": "property/5174219562287104/019f1502-c11d-767b-9aaf-dbe874082841.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://jasmedical.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6608026595371580275&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jas-medical-management",
      "poi_latitude": "25.9848903",
      "poi_longitude": "-80.2101766",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 954-965-6001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a996-7267-ade6-14a6342b9fbf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a996-7267-ade6-14a6342b9fbf",
        "storage_key": "property/5174219562287104/019f1500-a996-7267-ade6-14a6342b9fbf.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-8mh3smu2YgRc_t0ey1ttFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_f66357b917a331428c46a65a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "PharmaRx",
      "poi_type": "Health and Wellness",
      "poi_address": "11382 Miramar Pkwy, Miramar, FL 33025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-c8fd-741a-a9f1-ffd5bef67bd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-c8fd-741a-a9f1-ffd5bef67bd2",
        "storage_key": "property/5174219562287104/019f1502-c8fd-741a-a9f1-ffd5bef67bd2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.mygnp.com/pharmacies/pharmarx-miramar-fl-33025/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=5743667",
      "poi_directions_map_url": "https://maps.google.com/?cid=12519017470689482551&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pharmarx",
      "poi_latitude": "25.9781519",
      "poi_longitude": "-80.2976091",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 786-418-5383",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1503-0a53-7189-88f9-1dc7a478e140.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0a53-7189-88f9-1dc7a478e140",
        "storage_key": "property/5174219562287104/019f1503-0a53-7189-88f9-1dc7a478e140.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn7UGXuql2YgRNxdbnQ98vK0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_ac98fb7b2df5af92721e2e95",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "12401 Miramar Pkwy, Miramar, FL 33027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-9d3f-765b-be7c-95c0356d3320.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-9d3f-765b-be7c-95c0356d3320",
        "storage_key": "property/5174219562287104/019f1502-9d3f-765b-be7c-95c0356d3320.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/miramar-fl-pharmacies/12401-miramar-pkwy-miramar-fl-33027/storeid=7887?WT.mc_id=LS_GOOGLE_RX_7887",
      "poi_directions_map_url": "https://maps.google.com/?cid=14978470539655213178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "25.979622",
      "poi_longitude": "-80.3123411",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 954-538-8473",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1503-0a53-7189-88f9-1dc7a478e140.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0a53-7189-88f9-1dc7a478e140",
        "storage_key": "property/5174219562287104/019f1503-0a53-7189-88f9-1dc7a478e140.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh9tT5cil2YgRenDNspg33s8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_502ca59c933606a0a58f3a55",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "8001 Miramar Pkwy, Miramar, FL 33025, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-a1da-7411-a16b-c30741c85411.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-a1da-7411-a16b-c30741c85411",
        "storage_key": "property/5174219562287104/019f1502-a1da-7411-a16b-c30741c85411.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-8001+miramar+pkwy-miramar-fl-33025/id=6011",
      "poi_directions_map_url": "https://maps.google.com/?cid=14772092818780064297&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "25.9824394",
      "poi_longitude": "-80.24790430000002",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 954-437-9552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a991-709b-aeff-7efd6b6071ab",
        "storage_key": "property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQaxgETqv2YgRKQp8HCcEAc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_8502b2a857103f6d4d665072",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "11645 Red Rd H-1, Miramar, FL 33025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-c68e-704c-9f5a-e9306a9e86b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-c68e-704c-9f5a-e9306a9e86b5",
        "storage_key": "property/5174219562287104/019f1502-c68e-704c-9f5a-e9306a9e86b5.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://lafitness.com/Pages/clubhome.aspx?clubid=1402&Miramar-Florida+GYM",
      "poi_directions_map_url": "https://maps.google.com/?cid=4365604514889698969&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "25.9850669",
      "poi_longitude": "-80.29954699999999",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 954-317-1024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a991-709b-aeff-7efd6b6071ab",
        "storage_key": "property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBcpKTgCl2YgRmY7XIy2-lTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_accfd9dcd2389b51251da097",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "12531 Miramar Pkwy, Miramar, FL 33027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-76cf-73e3-a9f2-1e5dab380930.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-76cf-73e3-a9f2-1e5dab380930",
        "storage_key": "property/5174219562287104/019f1500-76cf-73e3-a9f2-1e5dab380930.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/miramar-fl?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=8621577474125014538&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "25.9804968",
      "poi_longitude": "-80.3135123",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 954-556-6449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a991-709b-aeff-7efd6b6071ab",
        "storage_key": "property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ7Cha8al2YgRCia7nAj_pXc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_96dae7514b6400d691c54f34",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "14954 Pines Blvd, Pembroke Pines, FL 33027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-c4fb-7018-9ba7-f1fb87f7a65a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-c4fb-7018-9ba7-f1fb87f7a65a",
        "storage_key": "property/5174219562287104/019f1502-c4fb-7018-9ba7-f1fb87f7a65a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.clubpilates.com/pembrokepines/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=8071935902638463729&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "26.0062671",
      "poi_longitude": "-80.3492162",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 954-500-2582",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a94c-723b-93c6-967d0a270b72",
        "storage_key": "property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlVyfIaKm2YgR8dp8vu9GBXA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_939c8c474a1da1196ef67a6c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Soulates Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "8205 Commerce Way Ste 130, Miami Lakes, FL 33016, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-cf2c-74fd-b7b6-658a5120f875.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-cf2c-74fd-b7b6-658a5120f875",
        "storage_key": "property/5174219562287104/019f1502-cf2c-74fd-b7b6-658a5120f875.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://soulatesstudio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4227429792726595586&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "soulates-studio",
      "poi_latitude": "25.9025367",
      "poi_longitude": "-80.3322781",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 305-527-8219",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a94c-723b-93c6-967d0a270b72",
        "storage_key": "property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfxMSWgK72YgRAjhfpP_Yqjo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_0eba02444a7dd682da1ae056",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Miramar Cultural Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2400 Civic Center Pl, Miramar, FL 33025, USA",
      "poi_short_description": "Centered around an 800-seat theater, this complex also offers 2 art galleries & a botanical garden.",
      "poi_long_description": "Centered around an 800-seat theater, this complex also offers 2 art galleries & a botanical garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-ab9e-7580-979d-60476b42cecc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-ab9e-7580-979d-60476b42cecc",
        "storage_key": "property/5174219562287104/019f1502-ab9e-7580-979d-60476b42cecc.webp",
        "width": 600,
        "height": 412
      },
      "poi_business_url": "https://miramarculturalcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2488703510774905866&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miramar-cultural-center",
      "poi_latitude": "25.9861562",
      "poi_longitude": "-80.301495",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 954-602-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a991-709b-aeff-7efd6b6071ab",
        "storage_key": "property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0UrM3sKl2YgRCnwBR6imiSI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cultural_center"
    },
    {
      "id": "ec_b58487590386aa65c5192f4c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "River Run Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9400 Miramar Blvd, Miramar, FL 33025, USA",
      "poi_short_description": "Waterfront park offering a walking trail & fishing dock, plus a tennis court, playground & pavilion.",
      "poi_long_description": "Waterfront park offering a walking trail & fishing dock, plus a tennis court, playground & pavilion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-dc11-736e-8970-6222dbdcde00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-dc11-736e-8970-6222dbdcde00",
        "storage_key": "property/5174219562287104/019f1502-dc11-736e-8970-6222dbdcde00.webp",
        "width": 1280,
        "height": 736
      },
      "poi_business_url": "https://www.miramarfl.gov/Parks/River-Run-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10619514617568715889&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-run-park",
      "poi_latitude": "25.9860221",
      "poi_longitude": "-80.269694",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 954-602-3172",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a9b0-7167-9862-e3362e729f7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a9b0-7167-9862-e3362e729f7b",
        "storage_key": "property/5174219562287104/019f1500-a9b0-7167-9862-e3362e729f7b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJO5hUkVCv2YgRcWRAs0cYYJM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_16cce7ece8b26a9d54da96c8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Ansin Sports Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10801 Miramar Blvd, Miramar, FL 33025, USA",
      "poi_short_description": "Large, modern running track with pavilions, an outdoor basketball court & a meeting room.",
      "poi_long_description": "Large, modern running track with pavilions, an outdoor basketball court & a meeting room.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-d257-717c-9732-9dbea761bf2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-d257-717c-9732-9dbea761bf2b",
        "storage_key": "property/5174219562287104/019f1502-d257-717c-9732-9dbea761bf2b.webp",
        "width": 1280,
        "height": 681
      },
      "poi_business_url": "https://www.miramarfl.gov/Rental-Facilities/Ansin-Sports-Complex",
      "poi_directions_map_url": "https://maps.google.com/?cid=11921266769484703597&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ansin-sports-complex",
      "poi_latitude": "25.9880027",
      "poi_longitude": "-80.29110709999999",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 954-602-4990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a991-709b-aeff-7efd6b6071ab",
        "storage_key": "property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-ceZpuWl2YgRbefNG_fYcKU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "ec_63c653bf47480388af7575e0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Miramar Pineland Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3600 S University Dr, Miramar, FL 33025, USA",
      "poi_short_description": "Regional park & nature center spanning wetlands, flatwoods & prairie land with a boardwalk & trails.",
      "poi_long_description": "Regional park & nature center spanning wetlands, flatwoods & prairie land with a boardwalk & trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-caee-75b8-85c6-12ac54865bc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-caee-75b8-85c6-12ac54865bc9",
        "storage_key": "property/5174219562287104/019f1502-caee-75b8-85c6-12ac54865bc9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.broward.org/Parks/Pages/park.aspx?park=25",
      "poi_directions_map_url": "https://maps.google.com/?cid=10683631611221094130&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miramar-pineland-park",
      "poi_latitude": "25.9774105",
      "poi_longitude": "-80.24748629999999",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 954-357-8776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a9b0-7167-9862-e3362e729f7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a9b0-7167-9862-e3362e729f7b",
        "storage_key": "property/5174219562287104/019f1500-a9b0-7167-9862-e3362e729f7b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwYNdFzyv2YgR8q73mVjiQ5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_0c0c97f330dadaa504fc1c30",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Miramar Paw Central Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16800 Miramar Pkwy, Miramar, FL 33027, USA",
      "poi_short_description": "Spacious canine hangout with separate areas for small and large dogs, plus friendly staff and training opportunities.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-d9b8-7064-9044-7f7d1506960f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-d9b8-7064-9044-7f7d1506960f",
        "storage_key": "property/5174219562287104/019f1502-d9b8-7064-9044-7f7d1506960f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://miramarparks.org/1703/Paw-Central-Dog-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=7771688986238676074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miramar-paw-central-dog-park",
      "poi_latitude": "25.9834174",
      "poi_longitude": "-80.36791029999999",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 954-883-6950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a9b0-7167-9862-e3362e729f7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a9b0-7167-9862-e3362e729f7b",
        "storage_key": "property/5174219562287104/019f1500-a9b0-7167-9862-e3362e729f7b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJfWvPGkaj2YgRamyS8fSV2ms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_05dc773a0dd82e9cbdfcba01",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Miramar Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16801 Miramar Pkwy, Miramar, FL 33027, USA",
      "poi_short_description": "Recreation area with pools, a water park, picnic areas, athletic fields & lakeside walking trails.",
      "poi_long_description": "Recreation area with pools, a water park, picnic areas, athletic fields & lakeside walking trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-834c-71c6-a27e-ade721889258.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-834c-71c6-a27e-ade721889258",
        "storage_key": "property/5174219562287104/019f1500-834c-71c6-a27e-ade721889258.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "http://miramarparks.org/Facilities/Facility/Details/Miramar-Regional-Park-14",
      "poi_directions_map_url": "https://maps.google.com/?cid=18242619704004847654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miramar-regional-park",
      "poi_latitude": "25.9825",
      "poi_longitude": "-80.3711111",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 954-883-6950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a9b0-7167-9862-e3362e729f7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a9b0-7167-9862-e3362e729f7b",
        "storage_key": "property/5174219562287104/019f1500-a9b0-7167-9862-e3362e729f7b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcfb1fPSj2YgRJijAnffNKv0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_51b1079c5300142eafc25c3c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Vizcaya Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14200 SW 55th St, Miramar, FL 33027, USA",
      "poi_short_description": "City park with a regulation-size football field, basketball courts, a playground & picnic tables.",
      "poi_long_description": "City park with a regulation-size football field, basketball courts, a playground & picnic tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-d5e5-745f-8d20-e8221695da3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-d5e5-745f-8d20-e8221695da3d",
        "storage_key": "property/5174219562287104/019f1502-d5e5-745f-8d20-e8221695da3d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.miramarfl.gov/Facilities/Facility/Details/Vizcaya-Park-32",
      "poi_directions_map_url": "https://maps.google.com/?cid=11312880337415086186&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vizcaya-park",
      "poi_latitude": "25.9580177",
      "poi_longitude": "-80.3377311",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 954-883-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a9b0-7167-9862-e3362e729f7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a9b0-7167-9862-e3362e729f7b",
        "storage_key": "property/5174219562287104/019f1500-a9b0-7167-9862-e3362e729f7b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJndrjNFmk2YgRaqAgirps_5w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_9a72ea883250684fbb33c61e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Monarch Lakes Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2150 SW 136th Ave, Miramar, FL 33027, USA",
      "poi_short_description": "Park featuring a baseball field and tennis courts, along with playgrounds.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-da90-7569-9d66-c3ed2eae7b7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-da90-7569-9d66-c3ed2eae7b7e",
        "storage_key": "property/5174219562287104/019f1502-da90-7569-9d66-c3ed2eae7b7e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://miramarculturalcenter.org/Facilities/Facility/Details/Monarch-Lakes-Park-74",
      "poi_directions_map_url": "https://maps.google.com/?cid=12398694636937569968&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "monarch-lakes-park",
      "poi_latitude": "25.9885401",
      "poi_longitude": "-80.32788599999999",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 954-602-3172",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a9b0-7167-9862-e3362e729f7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a9b0-7167-9862-e3362e729f7b",
        "storage_key": "property/5174219562287104/019f1500-a9b0-7167-9862-e3362e729f7b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ22-ls82l2YgRsGY0yRQDEaw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_e0045f8449c33d601a3c225a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Miramar Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16801 Miramar Pkwy, Miramar, FL 33027, USA",
      "poi_short_description": "Recreation area with pools, a water park, picnic areas, athletic fields & lakeside walking trails.",
      "poi_long_description": "Recreation area with pools, a water park, picnic areas, athletic fields & lakeside walking trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-834c-71c6-a27e-ade721889258.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-834c-71c6-a27e-ade721889258",
        "storage_key": "property/5174219562287104/019f1500-834c-71c6-a27e-ade721889258.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "http://miramarparks.org/Facilities/Facility/Details/Miramar-Regional-Park-14",
      "poi_directions_map_url": "https://maps.google.com/?cid=18242619704004847654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miramar-regional-park",
      "poi_latitude": "25.9825",
      "poi_longitude": "-80.3711111",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 954-883-6950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a9b0-7167-9862-e3362e729f7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a9b0-7167-9862-e3362e729f7b",
        "storage_key": "property/5174219562287104/019f1500-a9b0-7167-9862-e3362e729f7b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcfb1fPSj2YgRJijAnffNKv0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_be090da11caa4d6944c3c038",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Silver Shores Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15700 Pembroke Rd, Miramar, FL 33029, USA",
      "poi_short_description": "Sports and recreation venue with a pavillion and playground, as well as tennis courts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-df3b-749e-9f62-4736e1797a30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-df3b-749e-9f62-4736e1797a30",
        "storage_key": "property/5174219562287104/019f1502-df3b-749e-9f62-4736e1797a30.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.miramarparks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2458685182866981365&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "silver-shores-park",
      "poi_latitude": "25.9929057",
      "poi_longitude": "-80.358499",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 954-602-3172",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a9b0-7167-9862-e3362e729f7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a9b0-7167-9862-e3362e729f7b",
        "storage_key": "property/5174219562287104/019f1500-a9b0-7167-9862-e3362e729f7b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUZpXlgWk2YgR9YFNqyUBHyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_87af796a80cec76f5c58b186",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Miramar Town Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "2300 Civic Center Pl, Miramar, FL 33025, USA",
      "poi_short_description": "Mediterranean-style mixed-use complex including the new city hall, shops, offices & residences.",
      "poi_long_description": "Mediterranean-style mixed-use complex including the new city hall, shops, offices & residences.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-9d15-713f-b7aa-cba4940b7bee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-9d15-713f-b7aa-cba4940b7bee",
        "storage_key": "property/5174219562287104/019f1500-9d15-713f-b7aa-cba4940b7bee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.miramarfl.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1245556521042882486&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miramar-town-center",
      "poi_latitude": "25.985829",
      "poi_longitude": "-80.29988",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 954-602-4357",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-ad77-74fb-a2da-39a46c4de87a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-ad77-74fb-a2da-39a46c4de87a",
        "storage_key": "property/5174219562287104/019f1500-ad77-74fb-a2da-39a46c4de87a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1evspcKl2YgRtq9ugA4bSRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "ec_12d828899a69a7f49996960b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Broward County Transit (Central Terminal)",
      "poi_type": "Transportation & Transit",
      "poi_address": "101 NW 1st Ave, Fort Lauderdale, FL 33301, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-dba0-739d-8e30-cbebdaf6081e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-dba0-739d-8e30-cbebdaf6081e",
        "storage_key": "property/5174219562287104/019f1502-dba0-739d-8e30-cbebdaf6081e.webp",
        "width": 1280,
        "height": 962
      },
      "poi_business_url": "https://www.broward.org/BCT/Riders/Pages/JustTryIt.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=408228831615665290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broward-county-transit-central-terminal",
      "poi_latitude": "26.1232797",
      "poi_longitude": "-80.145039",
      "poi_miles_from_property": "18.6 mi",
      "poi_walking_minutes": "6 hours 53 mins",
      "poi_biking_minutes": "1 hour 45 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 954-357-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a991-709b-aeff-7efd6b6071ab",
        "storage_key": "property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ52vyvv8B2YgRikSGn_VRqgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_438d446ce0bfbf35e6d2c10c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Miramar Regional Park Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "2901 SW 172nd Ave, Miramar, FL 33029, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16735395100172874793&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miramar-regional-park-park-and-ride",
      "poi_latitude": "25.9822394",
      "poi_longitude": "-80.3744279",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1503-0a8e-762f-9b56-694f11f06b75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0a8e-762f-9b56-694f11f06b75",
        "storage_key": "property/5174219562287104/019f1503-0a8e-762f-9b56-694f11f06b75.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJQSEDc8Kj2YgRKfSd-SwRQOg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_5ad946742b5ab5895c7bf3b3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Pembroke Lakes Mall",
      "poi_type": "Transportation & Transit",
      "poi_address": "11401 Pines Blvd, Pembroke Pines, FL 33026, USA",
      "poi_short_description": "Spacious shopping center with department stores & national brands, a food court & a movie theater.",
      "poi_long_description": "Spacious shopping center with department stores & national brands, a food court & a movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-4c38-75a5-8c26-9fa9897cd9fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-4c38-75a5-8c26-9fa9897cd9fb",
        "storage_key": "property/5174219562287104/019f1500-4c38-75a5-8c26-9fa9897cd9fb.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "https://www.pembrokelakesmall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=14961678198434783584&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pembroke-lakes-mall",
      "poi_latitude": "26.0105689",
      "poi_longitude": "-80.3046253",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 954-436-3311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a94b-74e9-b4a6-dfafe7b5393a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a94b-74e9-b4a6-dfafe7b5393a",
        "storage_key": "property/5174219562287104/019f1500-a94b-74e9-b4a6-dfafe7b5393a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJj0Nc5G2m2YgRYGFpFQ2Pos8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_e4ada294bf767b460c8cc255",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Fort Lauderdale-Hollywood International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "100 Terminal Dr, Fort Lauderdale, FL 33315, USA",
      "poi_short_description": "Airport with free WiFi, a cell phone waiting lot & areas to observe planes taking off & landing.",
      "poi_long_description": "Airport with free WiFi, a cell phone waiting lot & areas to observe planes taking off & landing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-e9b8-72ce-b143-f0891ca5fd32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-e9b8-72ce-b143-f0891ca5fd32",
        "storage_key": "property/5174219562287104/019f1502-e9b8-72ce-b143-f0891ca5fd32.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.broward.org/airport/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3089526096205892582&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-lauderdale-hollywood-international-airport",
      "poi_latitude": "26.0731729",
      "poi_longitude": "-80.1512317",
      "poi_miles_from_property": "17.1 mi",
      "poi_walking_minutes": "6 hours 17 mins",
      "poi_biking_minutes": "1 hour 31 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 866-435-9355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-ad7e-70ac-be79-e1bd6aa2601b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-ad7e-70ac-be79-e1bd6aa2601b",
        "storage_key": "property/5174219562287104/019f1500-ad7e-70ac-be79-e1bd6aa2601b.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9frI5Hqq2YgR5sumkJ0z4Co",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_ad5b0a2f0e9be05bd27c77ba",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Fort Lauderdale Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "500 Gulf Stream Way, Dania Beach, FL 33004, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-ea91-710b-a697-b8868df83d3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-ea91-710b-a697-b8868df83d3d",
        "storage_key": "property/5174219562287104/019f1502-ea91-710b-a697-b8868df83d3d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tri-rail.com/stations/fort-lauderdalehollywood-international-airport-at-dania-beach/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1078809497329506260&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-lauderdale-airport",
      "poi_latitude": "26.0616447",
      "poi_longitude": "-80.16561879999999",
      "poi_miles_from_property": "12.5 mi",
      "poi_walking_minutes": "4 hours 37 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1503-0a9c-7318-bf4b-77ec5e1a225f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0a9c-7318-bf4b-77ec5e1a225f",
        "storage_key": "property/5174219562287104/019f1503-0a9c-7318-bf4b-77ec5e1a225f.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJx53JMRWq2YgR1JekpIWz-A4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_ee92a2f7f6d6d20d188ab952",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Sheridan Street Tri-Rail Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Station, 2900 Sheridan St, Hollywood, FL 33021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-e56a-707c-88fb-df3191958fe2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-e56a-707c-88fb-df3191958fe2",
        "storage_key": "property/5174219562287104/019f1502-e56a-707c-88fb-df3191958fe2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tri-rail.com/stations/sheridan-street",
      "poi_directions_map_url": "https://maps.google.com/?cid=600547698094413711&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sheridan-street-tri-rail-station",
      "poi_latitude": "26.0319778",
      "poi_longitude": "-80.1678883",
      "poi_miles_from_property": "11.1 mi",
      "poi_walking_minutes": "4 hours 7 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 800-874-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a991-709b-aeff-7efd6b6071ab",
        "storage_key": "property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTX_gPsqr2YgRj5eYF_OSVQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_5e5103a8b391ab8bf6eb4be0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Fort Lauderdale",
      "poi_type": "Transportation & Transit",
      "poi_address": "101 NW 2nd Ave, Fort Lauderdale, FL 33311, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-e9d6-70ea-935e-3759eb596bdd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-e9d6-70ea-935e-3759eb596bdd",
        "storage_key": "property/5174219562287104/019f1502-e9d6-70ea-935e-3759eb596bdd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gobrightline.com/fort-lauderdale",
      "poi_directions_map_url": "https://maps.google.com/?cid=3758530637296426461&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-lauderdale",
      "poi_latitude": "26.1235832",
      "poi_longitude": "-80.1460689",
      "poi_miles_from_property": "18.7 mi",
      "poi_walking_minutes": "6 hours 55 mins",
      "poi_biking_minutes": "1 hour 45 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1503-0a9c-7318-bf4b-77ec5e1a225f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1503-0a9c-7318-bf4b-77ec5e1a225f",
        "storage_key": "property/5174219562287104/019f1503-0a9c-7318-bf4b-77ec5e1a225f.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7-OfwnsB2YgR3d15ebP7KDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_a99b5f204b66964a4bb11341",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Florida Tollway Gantry",
      "poi_type": "Transportation & Transit",
      "poi_address": "Florida's Tpke, Miramar, FL 33025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-eaf1-7639-900d-bef806f39941.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-eaf1-7639-900d-bef806f39941",
        "storage_key": "property/5174219562287104/019f1502-eaf1-7639-900d-bef806f39941.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10184099367231467553&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "florida-tollway-gantry",
      "poi_latitude": "25.9719016",
      "poi_longitude": "-80.25312400000001",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a991-709b-aeff-7efd6b6071ab",
        "storage_key": "property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNy080USv2YgRIbActWowVY0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "toll_station"
    },
    {
      "id": "ec_470616164268608dad4299db",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Pembroke Rd @ I-75",
      "poi_type": "Transportation & Transit",
      "poi_address": "Pembroke Pines, FL 33027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-f202-701f-bf89-c8e7a42a074e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-f202-701f-bf89-c8e7a42a074e",
        "storage_key": "property/5174219562287104/019f1502-f202-701f-bf89-c8e7a42a074e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12032754413588850997&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pembroke-rd--i-75",
      "poi_latitude": "25.9932102",
      "poi_longitude": "-80.3411103",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a991-709b-aeff-7efd6b6071ab",
        "storage_key": "property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU1kcEmCl2YgRNSl6C2Pu_KY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bridge"
    },
    {
      "id": "ec_4ebf4fc886faeb26f3013682",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "City of Miramar",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2300 Civic Center Pl, Miramar, FL 33025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-f572-768d-994d-7d3583648735.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-f572-768d-994d-7d3583648735",
        "storage_key": "property/5174219562287104/019f1502-f572-768d-994d-7d3583648735.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.miramarfl.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14775571933304694515&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-miramar",
      "poi_latitude": "25.9867157",
      "poi_longitude": "-80.30121079999999",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 954-602-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-ad77-74fb-a2da-39a46c4de87a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-ad77-74fb-a2da-39a46c4de87a",
        "storage_key": "property/5174219562287104/019f1500-ad77-74fb-a2da-39a46c4de87a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPVg9zMKl2YgR86bblWNgDc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_8b47a6cc8b998ed365191c83",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Miramar Police Headquarter",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11765 City Hall Promenade, Miramar, FL 33025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJz4u8r8Kl2YgRTN9ooEQl2c0/photos/AaVGc3kiPv2k_wm2K3F5n8jNBdbLtDhA_MEltzbxFcmVIVRuSRA0ltRn9KYfyDaR19gFGBdUotGTbZyCth-xZUSZuyFoktHdqj7KKLasDWaTha6WiSMpXUZcILFxjle8ia9Z1vI7yFdNegjFD5fmfSx1hOCWLzWPWBoDnY_zd0wvznJgrPeh4TEhMwnYFYcB9P8J8l9XIND1bI8FlkNyjYoHrkkQ9BCBNvPJlauUq7tHpHbBeURf482CDhQAlxvPzmo3ZJNMfVOZNiU0p0wl5AZ3VpyEW8jzA1ANITbn6ZwZY5GKzW-HY3Tqunw93QsPgW-EvaVXtPYs16nQWOGC5mn6JW52R2i75vQfCBpNabQNjPvzHwfI4NfGsbF5-4Qrzz9Q5zvOui0Yzuexy85ceKrgT_lubJqGMxT9-SICoelh0YETXKQL/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4800&maxHeightPx=4213",
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14832927824400670540&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miramar-police-headquarter",
      "poi_latitude": "25.9865696",
      "poi_longitude": "-80.3006295",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 954-602-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-ad77-74fb-a2da-39a46c4de87a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-ad77-74fb-a2da-39a46c4de87a",
        "storage_key": "property/5174219562287104/019f1500-ad77-74fb-a2da-39a46c4de87a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz4u8r8Kl2YgRTN9ooEQl2c0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "ec_4f7e9a427e3ae3ef63364ba8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Nova Southeastern University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3300 S University Dr, Fort Lauderdale, FL 33328, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-f963-770c-84e9-1a03fcca9d16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-f963-770c-84e9-1a03fcca9d16",
        "storage_key": "property/5174219562287104/019f1502-f963-770c-84e9-1a03fcca9d16.webp",
        "width": 1280,
        "height": 951
      },
      "poi_business_url": "http://www.nova.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12169842592624840886&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nova-southeastern-university",
      "poi_latitude": "26.0791417",
      "poi_longitude": "-80.2465466",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 800-541-6682",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a94c-723b-93c6-967d0a270b72",
        "storage_key": "property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP64CCSWo2YgRtpDSAVz346g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_94c954267e4d37ddc3996c4c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Broward College Miramar West Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1930 SW 145th Ave, Miramar, FL 33027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-f56d-76ef-846e-acb39bf8febb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-f56d-76ef-846e-acb39bf8febb",
        "storage_key": "property/5174219562287104/019f1502-f56d-76ef-846e-acb39bf8febb.webp",
        "width": 500,
        "height": 650
      },
      "poi_business_url": "http://www.broward.edu/locations/miramarwest/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=11865081465224118853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broward-college-miramar-west-campus",
      "poi_latitude": "25.992093",
      "poi_longitude": "-80.339823",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 954-201-7350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a94c-723b-93c6-967d0a270b72",
        "storage_key": "property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-YDRCyOk2YgRRULBjbo8qaQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_a1c852e40b7d14770360d158",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "FIU at I-75",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1930 SW 145th Ave, Miramar, FL 33027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-f5df-728c-a68d-dd8fb6f3afb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-f5df-728c-a68d-dd8fb6f3afb3",
        "storage_key": "property/5174219562287104/019f1502-f5df-728c-a68d-dd8fb6f3afb3.webp",
        "width": 851,
        "height": 315
      },
      "poi_business_url": "http://miramar.fiu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6033864405644724566&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fiu-at-i-75",
      "poi_latitude": "25.9921169",
      "poi_longitude": "-80.3398225",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 954-438-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a94c-723b-93c6-967d0a270b72",
        "storage_key": "property/5174219562287104/019f1500-a94c-723b-93c6-967d0a270b72.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2-FxCSOk2YgRVslTSbWXvFM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_7cb51306d46f5772552741a4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Memorial Hospital Miramar",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1901 SW 172nd Ave, Miramar, FL 33029, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-8028-77d6-93b6-8f91fbe3d2cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-8028-77d6-93b6-8f91fbe3d2cc",
        "storage_key": "property/5174219562287104/019f1500-8028-77d6-93b6-8f91fbe3d2cc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.mhs.net/locations/memorial-hospital-miramar",
      "poi_directions_map_url": "https://maps.google.com/?cid=18168369644712303855&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hospital-miramar",
      "poi_latitude": "25.9909485",
      "poi_longitude": "-80.3732483",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 954-538-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a996-7267-ade6-14a6342b9fbf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a996-7267-ade6-14a6342b9fbf",
        "storage_key": "property/5174219562287104/019f1500-a996-7267-ade6-14a6342b9fbf.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1-bI8_Gj2YgR7xwRhe4DI_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_243dabfab7a2032337b9559c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Memorial Hospital West",
      "poi_type": "Major Employers & Offices",
      "poi_address": "703 N Flamingo Rd, Pembroke Pines, FL 33028, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-8087-74e7-98c5-edbbb387c1bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-8087-74e7-98c5-edbbb387c1bb",
        "storage_key": "property/5174219562287104/019f1500-8087-74e7-98c5-edbbb387c1bb.webp",
        "width": 1280,
        "height": 826
      },
      "poi_business_url": "https://www.mhs.net/locations/memorial-west?utm_source=gmb&utm_medium=organic&utm_campaign=hospital_locations&utm_content=mhw",
      "poi_directions_map_url": "https://maps.google.com/?cid=8544305655893128439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hospital-west",
      "poi_latitude": "26.0125991",
      "poi_longitude": "-80.3101755",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 954-436-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a996-7267-ade6-14a6342b9fbf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a996-7267-ade6-14a6342b9fbf",
        "storage_key": "property/5174219562287104/019f1500-a996-7267-ade6-14a6342b9fbf.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJOe4reW-m2YgR9_Teb7l4k3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_300636ce8dafef02eda5a9e7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Memorial Hospital Pembroke",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7800 Sheridan St, Pembroke Pines, FL 33024, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1502-fed8-7750-82bf-da6bc6107620.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1502-fed8-7750-82bf-da6bc6107620",
        "storage_key": "property/5174219562287104/019f1502-fed8-7750-82bf-da6bc6107620.webp",
        "width": 820,
        "height": 546
      },
      "poi_business_url": "https://www.mhs.net/locations/memorial-pembroke?utm_source=gmb&utm_medium=organic&utm_campaign=hospital_locations&utm_content=mhp",
      "poi_directions_map_url": "https://maps.google.com/?cid=4135444014617616111&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hospital-pembroke",
      "poi_latitude": "26.0297703",
      "poi_longitude": "-80.2462796",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 954-962-9650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a996-7267-ade6-14a6342b9fbf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a996-7267-ade6-14a6342b9fbf",
        "storage_key": "property/5174219562287104/019f1500-a996-7267-ade6-14a6342b9fbf.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_8rNKO6o2YgR717Mt2sMZDk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_c4b9f6604f98ed2729bf07b3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Spirit Airlines IT HDQ",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2889 N Commerce Pkwy, Miramar, FL 33025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13395827047999152666&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spirit-airlines-it-hdq",
      "poi_latitude": "25.9832077",
      "poi_longitude": "-80.2799453",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a991-709b-aeff-7efd6b6071ab",
        "storage_key": "property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPYTjVxql2YgRGiKP3LmJ57k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_f781b5929edc149b6a1663f0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "poi_name": "Miramar Commerce Park",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11281 Interchange Cir S Unit #5, Miramar, FL 33025, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1503-00c6-75ef-91da-2a20d48816bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1503-00c6-75ef-91da-2a20d48816bf",
        "storage_key": "property/5174219562287104/019f1503-00c6-75ef-91da-2a20d48816bf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5200692024633545274&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miramar-commerce-park",
      "poi_latitude": "25.9734821",
      "poi_longitude": "-80.29545999999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-a991-709b-aeff-7efd6b6071ab",
        "storage_key": "property/5174219562287104/019f1500-a991-709b-aeff-7efd6b6071ab.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Q0rsyWl2YgROlJ9iteRLEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    }
  ],
  "office_hours": [
    {
      "id": "custom_ebfe0bdd-d6ac-434e-8cc7-2e715bf27472",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_371f9806-e172-4086-9fa0-5df669ed21be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_ebd25f16-535f-4ec6-a5ed-7bb309b79cbd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_b4033797-d386-4e9a-93da-a55e981a3429",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_5c2c7d1e-f1ed-43c8-a91f-2fa91e4c91ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_acfb4a9f-fcb3-4d82-98d3-6c69ca24b10d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_afc22c05af62a18404549730",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "rating": "5",
      "name": "false",
      "text": "Modera Town Center Apartments is absolutely a phenomenal place to call home.Every apartment is installed with a washer and dryer, also a dish washer every kitchen is updated with modern day appliances the great location to near by schools, shopping centers ,and restaurants just minutes away I highly recommend this luxury place to call your home",
      "date": "false",
      "title": "Tell everyone!"
    },
    {
      "id": "ec_5ed5f01ff69325c3858f90e1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "rating": "5",
      "name": "false",
      "text": "Absolutely the best for the money. The amenities are excellent and the staff is super friendly and very attentive to your needs. I love living here!",
      "date": "false",
      "title": "Modera Town Center"
    },
    {
      "id": "ec_399b5172306fdcb7a50b5277",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "rating": "4",
      "name": "false",
      "text": "I have lived here exactly one year in the apartment section of the complex and am one of the first tenants of this new location. The two apartment buildings are fairly large 4-5 stories but there are elevators! They do offer three story town homes as well. This is a family and pet friendly location, as well as a great place for couples. The buildings and surrounding areas are very well maintained. It is very calm and quiet. I could barely even tell I have neighbors! A bonus is there are currently constructing a police station in this multi use location. This just adds even more safety to where we live. There is also city hall, performing art center, a library, college campus, and restaurants within walking distance! There are also monthly events including a resident catered breakfast to show appreciation and provide a chance to get to know your neighbors. The only negative thing I have to say is the cell phone coverage is not the best when inside the building. I had to purchase a network extender with my cell phone carrier in order to guarantee good service. I would certainly recommend living here!",
      "date": "false",
      "title": "Safe place to call home"
    },
    {
      "id": "ec_e5d5449202af1e073d4ffa55",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "rating": "4",
      "name": "false",
      "text": "Very safe and quiet location. Restaurants city hall and a future police station all in the same area. Very dog and family friendly! I would reccomend anyone live here.",
      "date": "false",
      "title": "Great place!"
    },
    {
      "id": "ec_3355e025498b4c7773aa6898",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "rating": "5",
      "name": "false",
      "text": "I moved over a year ago as a single mom with my son. Have to say this has been the best experience we have had thus far and we call it home. Very spacious,affordable, convenient to his school and shopping. They are always doing things for their residents.",
      "date": "false",
      "title": "modera Miramar towncenter"
    },
    {
      "id": "ec_64a210ed7dd27883dc913b0c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "rating": "4",
      "name": "false",
      "text": "Despite having lived a theft inside the parking lot, long walks to get to the premises, The trash in the parking lot constantly, although the latter is due to the neglect of residents, are very good social areas, if you have some Problem in your unit is given the corresponding service, garbage is collected every day, maintenance is constant, attention is good and pleasant, in short, the balance is positive.",
      "date": "false",
      "title": "There are many more good things ..."
    },
    {
      "id": "ec_14d44a9ae1e5b8bd60ea2569",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "rating": "5",
      "name": "false",
      "text": "Being part of the Mosaic at Marimar community for many years has been an outstanding experience for my family and me. The entire team, from front office to management and maintenance -they consistently provides professional, attentive, and caring service…A sincere thank you to the management team, Juan and Melissa, for their continued support, understanding, and dedication; their attentiveness truly enhances the living experience and is deeply appreciated. And also Robert, the maintenance manager, for his exceptional reliability and consistently prompt response to any request -his commitment is definitely recognized…The community is peaceful, beautifully maintained, and truly feels like home. The weekly art and other events are also a wonderful touch, helping bring residents together and creating a strong sense of community. We are truly grateful for the many meaningful memories we’ve made here. The best!!!",
      "date": "false",
      "title": "Honestly Speaking "
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_854d3eb429e272a4ffc62706",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f14c3-eca9-7779-a99b-a3caf138ec3d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c3-eca9-7779-a99b-a3caf138ec3d",
        "storage_key": "property/5174219562287104/019f14c3-eca9-7779-a99b-a3caf138ec3d.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Mosaic at Miramar Town Center Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/cA7CzRWV71k"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-b907-7629-b479-299320431501",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "mosaic-at-miramar-town-center",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104"
    },
    {
      "lead_collector_id": "0198aa45-b969-72fc-9a4a-83ce7a4e8d38",
      "lead_source": "FACEBOOK_ADS",
      "name": "mosaic-at-miramar-town-center",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104"
    },
    {
      "lead_collector_id": "0198aa45-b9ce-71be-aed4-c7b4d23ea713",
      "lead_source": "LANDING_PAGE",
      "name": "mosaic-at-miramar-town-center",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "page_item_url": "apartments-with-pool-miramar-fl-451",
      "search_query": "apartments with pool in Miramar FL",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Miramar, FL",
      "h2_subtitle": "Discover premier apartments with a pool in Miramar, FL. Enjoy luxurious amenities and beautiful water views in a vibrant neighborhood.",
      "page_copy": "At Mosaic at Miramar Town Center, indulge in the ultimate relaxation at our shimmering pool, a key feature of our Miramar, FL apartments. Our community offers upscale living with one, two, and three-bedroom layouts designed for comfort and style. Each residence is equipped with premium amenities, including in-unit washers and dryers, vinyl plank flooring, and stunning lake views.\n\nBeyond the spacious interiors, residents enjoy state-of-the-art facilities such as a modern fitness center and serene environments. Located in the heart of Miramar, Mosaic at Miramar Town Center places you near shopping, dining, and entertainment while offering the perfect retreat at the end of the day. Schedule a tour today and dive into a lifestyle of luxury and convenience in your new apartment home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, accent chairs, coffee table, and a TV on a cabinet.",
        "public_id": "019f6c0f-eb0a-709e-af6e-a75d42f42964",
        "storage_key": "property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Miramar, FL",
      "seo_description": "Explore Mosaic at Miramar Town Center. Apartments with pool, modern amenities, and convenient location in Miramar, FL.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "page_item_url": "water-view-apartments-broward-county-231",
      "search_query": "water view apartments in Broward County",
      "category": "Amenity",
      "h1_title": "Water View Apartments in Broward County",
      "h2_subtitle": "Discover breathtaking water view apartments in Broward County. Find serene living spaces with picturesque vistas in Miramar.",
      "page_copy": "Mosaic at Miramar Town Center offers exquisite water view apartments nestled in the heart of Broward County. With options ranging from one to three-bedroom floor plans, these residences showcase stunning lake views that provide a tranquil escape from the everyday hustle.\n\nEach apartment combines style and functionality, featuring modern interiors with vinyl plank flooring, sleek counters, and in-unit washers and dryers. Outside, residents can unwind by the fountain view or take advantage of the shimmering pool and state-of-the-art fitness center. Located in vibrant Miramar, these apartments provide easy access to local shopping and dining while offering a peaceful lakeside retreat. Experience the beauty and convenience of living at Mosaic today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, accent chairs, coffee table, and a TV on a cabinet.",
        "public_id": "019f6c0f-eb0a-709e-af6e-a75d42f42964",
        "storage_key": "property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Water View Apartments in Broward County",
      "seo_description": "Discover Mosaic at Miramar's water view apartments in Broward County. Enjoy premium amenities and scenic views in your new home.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "page_item_url": "miramar-fl-apartments-with-fitness-center-621",
      "search_query": "Miramar FL apartments with fitness center",
      "category": "Amenity",
      "h1_title": "Miramar FL Apartments with Fitness Center",
      "h2_subtitle": "Explore Miramar, FL apartments with a modern fitness center. Stay fit and healthy with top amenities in a vibrant community.",
      "page_copy": "Embrace an active lifestyle at Mosaic at Miramar Town Center, where our state-of-the-art fitness center caters to residents in search of premium Miramar, FL apartments. Our community mixes luxury and convenience with one, two, and three-bedroom apartments, each designed with contemporary features and stylish finishes.\n\nResidents benefit from additional amenities including a sparkling pool, tranquil water views, and in-unit washers and dryers. Situated in the lively area of Miramar, you’re just moments away from local dining, shopping, and entertainment. At Mosaic, staying fit and comfortable is part of everyday life. Discover your perfect home today and enjoy the vibrant lifestyle you deserve.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, accent chairs, coffee table, and a TV on a cabinet.",
        "public_id": "019f6c0f-eb0a-709e-af6e-a75d42f42964",
        "storage_key": "property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Miramar FL Apartments with Fitness Center",
      "seo_description": "Stay healthy at Mosaic's Miramar, FL apartments featuring a modern fitness center. Enjoy luxury living in a vibrant location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "page_item_url": "apartments-with-walk-in-closets-33025-970",
      "search_query": "apartments with walk-in closets in 33025",
      "category": "Amenity",
      "h1_title": "Apartments with Walk-in Closets in 33025",
      "h2_subtitle": "Discover apartments with spacious walk-in closets in the 33025 area. Enjoy luxury living in Miramar with premium amenities.",
      "page_copy": "Find your perfect space at Mosaic at Miramar Town Center, featuring apartments with generous walk-in closets located in Miramar's 33025 zip code. Each one, two, or three-bedroom apartment is crafted for optimal living with modern comfort in mind. Residents delight in ample storage solutions and stylish interiors, including vinyl plank flooring and sleek counters.\n\nBeyond the impressive closet space, Mosaic provides a host of amenities designed to enhance your daily life. Dive into our shimmering pool, workout in the advanced fitness center, or simply enjoy tranquil lake views from your own window. Conveniently located near shopping, dining, and entertainment, our community embodies the ideal blend of luxury and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, accent chairs, coffee table, and a TV on a cabinet.",
        "public_id": "019f6c0f-eb0a-709e-af6e-a75d42f42964",
        "storage_key": "property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Walk-in Closets in 33025",
      "seo_description": "Explore Mosaic's Miramar apartments with spacious walk-in closets in the 33025 area. Enjoy luxury amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "page_item_url": "apartments-in-unit-laundry-near-miramar-town-center-75",
      "search_query": "apartments with in-unit laundry near Miramar Town Center",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry Near Miramar",
      "h2_subtitle": "Explore convenient apartments with in-unit laundry near Miramar Town Center. Enjoy modern amenities and comfortable living spaces.",
      "page_copy": "Experience the convenience and comfort of living at Mosaic at Miramar Town Center, where each apartment is equipped with in-unit laundry facilities. These thoughtfully designed one, two, and three-bedroom homes offer residents the luxury of effortless laundry care alongside beautifully finished interiors.\n\nNestled near the vibrant Miramar Town Center, Mosaic also provides access to a range of premium amenities, including a state-of-the-art fitness center, a sparkling pool, and scenic lake views. With the added benefit of nearby shopping and dining options, Mosaic presents an ideal blend of convenience, modern living, and tranquility. Make Mosaic at Miramar Town Center your new home and enjoy a seamless lifestyle today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, accent chairs, coffee table, and a TV on a cabinet.",
        "public_id": "019f6c0f-eb0a-709e-af6e-a75d42f42964",
        "storage_key": "property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry Near Miramar",
      "seo_description": "Discover Mosaic's apartments with in-unit laundry near Miramar Town Center. Enjoy modern living and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-miramar-fl-869",
      "search_query": "one bedroom apartments miramar fl",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Miramar, FL",
      "h2_subtitle": "Discover stylish one bedroom apartments in Miramar, FL. Enjoy modern amenities and a vibrant community at Mosaic.",
      "page_copy": "Welcome to Mosaic at Miramar Town Center, offering exquisite one bedroom apartments in the heart of Miramar, FL. These well-crafted living spaces are designed with contemporary sophistication, featuring vinyl plank flooring, sleek counters, and ample natural light for a welcoming atmosphere.\n\nLocated in a vibrant setting, Mosaic provides access to top-notch amenities such as a state-of-the-art fitness center, a sparkling pool, and serene lake views. Our community is perfectly positioned near local dining, shopping, and entertainment options, making it an ideal place for those seeking both convenience and luxury. Discover exceptional one-bedroom living at Mosaic at Miramar Town Center today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, accent chairs, coffee table, and a TV on a cabinet.",
        "public_id": "019f6c0f-eb0a-709e-af6e-a75d42f42964",
        "storage_key": "property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Miramar, FL",
      "seo_description": "Find modern one bedroom apartments in Miramar, FL at Mosaic. Enjoy stylish living with premium amenities in a vibrant location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-broward-county-405",
      "search_query": "two bedroom apartments in broward county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Broward County",
      "h2_subtitle": "Explore elegant two bedroom apartments in Broward County at Mosaic. Enjoy exceptional amenities and a prime location in Miramar, FL.",
      "page_copy": "Discover the perfect blend of comfort and style with the two-bedroom apartments at Mosaic at Miramar Town Center, ideally situated in Broward County. Our spacious layouts offer ample room for relaxation and entertaining, complete with modern finishes like vinyl plank flooring and sleek countertops.\n\nResidents of Mosaic enjoy a variety of premium amenities, including a sparkling pool, a well-equipped fitness center, and scenic views of the lake. Located near a wealth of shopping, dining, and entertainment options, our community offers the best of both convenience and luxury. Make Mosaic at Miramar Town Center your new home and experience the finest in two-bedroom living in Broward County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, accent chairs, coffee table, and a TV on a cabinet.",
        "public_id": "019f6c0f-eb0a-709e-af6e-a75d42f42964",
        "storage_key": "property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Broward County",
      "seo_description": "Find elegant two bedroom apartments in Broward County at Mosaic. Enjoy modern amenities and vibrant living in Miramar, FL.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "page_item_url": "three-bedroom-flats-near-33025-726",
      "search_query": "three bedroom flats near 33025",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Flats Near 33025",
      "h2_subtitle": "Find spacious three bedroom flats near 33025 at Mosaic. Enjoy modern amenities and vibrant living in Miramar, FL.",
      "page_copy": "Mosaic at Miramar Town Center offers expansive three-bedroom flats ideally situated near the 33025 area. These well-appointed homes are perfect for families and those needing extra space, featuring premium vinyl plank flooring and modern counters.\n\nResidents of Mosaic enjoy access to a variety of upscale amenities, including a shimmering pool, cutting-edge fitness center, and beautiful water views. Located in a vibrant neighborhood, our community ensures you're never far from shopping, dining, and entertainment options. Experience the perfect combination of comfort and convenience in a three-bedroom flat at Mosaic at Miramar Town Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, accent chairs, coffee table, and a TV on a cabinet.",
        "public_id": "019f6c0f-eb0a-709e-af6e-a75d42f42964",
        "storage_key": "property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Flats Near 33025",
      "seo_description": "Discover spacious three-bedroom flats near 33025 at Mosaic. Enjoy premium amenities and vibrant community living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "page_item_url": "apartments-near-vargas-university-miramar-908",
      "search_query": "apartments near Vargas University Miramar",
      "category": "School",
      "h1_title": "Apartments Near Vargas University, Miramar",
      "h2_subtitle": "Find modern apartments near Vargas University in Miramar. Live close to campus with great amenities at Mosaic.",
      "page_copy": "Welcome to Mosaic at Miramar Town Center, where you'll find ideal apartments near Vargas University in Miramar, FL. This community is perfect for students and faculty looking to enjoy a short commute to campus while living in modern, stylish surroundings.\n\nOur residents enjoy beautifully designed one, two, and three-bedroom floor plans, complete with luxury finishes, and essential amenities such as a well-equipped fitness center and a sparkling pool. Located conveniently near shopping, dining, and entertainment, Mosaic offers both a vibrant lifestyle and prime access to educational pursuits. Make Mosaic your home and enjoy the best of Miramar living near Vargas University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, accent chairs, coffee table, and a TV on a cabinet.",
        "public_id": "019f6c0f-eb0a-709e-af6e-a75d42f42964",
        "storage_key": "property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Vargas University, Miramar",
      "seo_description": "Find stylish apartments near Vargas University, Miramar at Mosaic. Enjoy modern amenities and vibrant community living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "page_item_url": "apartments-close-to-fiu-broward-324",
      "search_query": "apartments close to Florida International University Broward",
      "category": "School",
      "h1_title": "Apartments Close to FIU Broward",
      "h2_subtitle": "Explore apartments close to Florida International University in Broward at Mosaic. Enjoy convenience, comfort, and modern amenities.",
      "page_copy": "Discover Mosaic at Miramar Town Center, your premier choice for apartments close to Florida International University (FIU) Broward. Our community offers exceptional living with easy access to campus and beyond, perfect for students and faculty alike.\n\nChoose from a variety of spacious floor plans featuring upscale finishes such as vinyl plank flooring and modern countertops. Residents enjoy premium amenities including a state-of-the-art fitness center, a refreshing pool, and stunning water views. Located in a vibrant area with plenty of dining and shopping options, Mosaic offers both convenience and style near FIU Broward.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, accent chairs, coffee table, and a TV on a cabinet.",
        "public_id": "019f6c0f-eb0a-709e-af6e-a75d42f42964",
        "storage_key": "property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to FIU Broward",
      "seo_description": "Find convenient apartments close to FIU Broward at Mosaic. Enjoy modern living with premium amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "page_item_url": "rentals-near-broward-college-fl-629",
      "search_query": "rentals near Broward College FL",
      "category": "School",
      "h1_title": "Rentals Near Broward College, FL",
      "h2_subtitle": "Discover rentals near Broward College, FL at Mosaic. Enjoy a vibrant lifestyle with modern amenities and a convenient location.",
      "page_copy": "Mosaic at Miramar Town Center offers ideal rentals near Broward College, FL, combining convenience with contemporary living. Our community is perfect for students and staff seeking modern apartments just a short drive from campus.\n\nWith a selection of thoughtfully designed floor plans, Mosaic provides comfortable living spaces equipped with top-tier amenities like in-home washers and dryers. Residents can also take advantage of our shimmering pool and well-equipped fitness center. Situated in a bustling area with easy access to shopping and dining, Mosaic is the perfect place to balance academic commitments and leisure activities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, accent chairs, coffee table, and a TV on a cabinet.",
        "public_id": "019f6c0f-eb0a-709e-af6e-a75d42f42964",
        "storage_key": "property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Broward College, FL",
      "seo_description": "Find stylish rentals near Broward College, FL at Mosaic. Enjoy modern living with premium amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "page_item_url": "apartments-by-city-college-hollywood-789",
      "search_query": "apartments by City College Hollywood",
      "category": "School",
      "h1_title": "Apartments by City College Hollywood",
      "h2_subtitle": "Explore apartments by City College Hollywood at Mosaic, where modern comfort meets educational convenience.",
      "page_copy": "Discover vibrant living at Mosaic at Miramar Town Center, offering exceptional apartments by City College Hollywood. Our community is perfectly positioned for those seeking a blend of convenience and style, just a short commute from the college.\n\nChoose from a selection of elegant one, two, or three-bedroom floor plans that cater to various lifestyle needs. Each apartment boasts modern finishes and premium features, such as vinyl plank flooring and serene lake views. Residents enjoy a full suite of amenities, including a state-of-the-art fitness center and a refreshing pool. Mosaic at Miramar provides the perfect setting for students and professionals alike, ensuring a balanced lifestyle close to City College Hollywood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, accent chairs, coffee table, and a TV on a cabinet.",
        "public_id": "019f6c0f-eb0a-709e-af6e-a75d42f42964",
        "storage_key": "property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by City College Hollywood",
      "seo_description": "Find modern apartments by City College Hollywood at Mosaic. Enjoy top amenities and a convenient location, perfect for students and faculty.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "page_item_url": "apartments-near-lil-rascals-academy-miramar-451",
      "search_query": "apartments near Lil' Rascals Academy Miramar",
      "category": "School",
      "h1_title": "Apartments Near Lil' Rascals Academy",
      "h2_subtitle": "Discover apartments near Lil' Rascals Academy Miramar at Mosaic. Enjoy family-friendly amenities and a convenient location.",
      "page_copy": "Mosaic at Miramar Town Center offers a prime living experience with our apartments near Lil' Rascals Academy Miramar. Perfect for families, our community combines modern living with convenience, making school drop-offs a breeze.\n\nOur spacious one, two, and three-bedroom layouts are designed with families in mind, offering features like in-unit washers and dryers. Enjoy amenities that cater to all ages, including a sparkling pool and a modern fitness center. Situated in a vibrant neighborhood with easy access to shopping, dining, and recreational activities, Mosaic is an ideal choice for those seeking comfort near Lil' Rascals Academy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, accent chairs, coffee table, and a TV on a cabinet.",
        "public_id": "019f6c0f-eb0a-709e-af6e-a75d42f42964",
        "storage_key": "property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lil' Rascals Academy Miramar",
      "seo_description": "Find family-friendly apartments near Lil' Rascals Academy Miramar at Mosaic. Enjoy modern amenities and a convenient location for families.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "page_item_url": "rentals-close-to-precious-years-christian-learning-318",
      "search_query": "rentals close to Precious Years Christian Learning Miramar FL",
      "category": "School",
      "h1_title": "Rentals Close to Precious Years Christian",
      "h2_subtitle": "Explore rentals close to Precious Years Christian Learning Center in Miramar, FL. Enjoy modern conveniences and family-friendly amenities at Mosaic.",
      "page_copy": "Discover the ideal family home at Mosaic at Miramar Town Center, offering rentals close to Precious Years Christian Learning in Miramar, FL. Our community provides an inviting and convenient setting for families, with education right around the corner.\n\nChoose from a variety of spacious floor plans that cater to your family's needs, enhanced by modern amenities like in-unit washers and dryers. Families can unwind at our shimmering pool or get active at the state-of-the-art fitness center. With easy access to shopping, dining, and other local attractions, Mosaic provides everything a family needs while keeping you close to Precious Years Christian Learning Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, accent chairs, coffee table, and a TV on a cabinet.",
        "public_id": "019f6c0f-eb0a-709e-af6e-a75d42f42964",
        "storage_key": "property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to Precious Years Christian",
      "seo_description": "Find rentals close to Precious Years Christian Learning in Miramar, FL. Mosaic offers family-friendly living and modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "page_item_url": "apartments-near-rock-creek-academy-miramar-956",
      "search_query": "apartments near Rock Creek Academy Miramar",
      "category": "School",
      "h1_title": "Apartments Near Rock Creek Academy",
      "h2_subtitle": "Discover apartments near Rock Creek Academy Miramar at Mosaic. Enjoy a modern lifestyle with easy access to educational facilities.",
      "page_copy": "Mosaic at Miramar Town Center is your ideal destination for apartments near Rock Creek Academy Miramar. Our community effortlessly combines contemporary living with convenient access, making it perfect for families and professionals alike.\n\nOur one, two, and three-bedroom apartments offer stylish interiors and essential utilities such as in-unit washers and dryers. Residents can enjoy leisure time at the sparkling pool or stay fit in our state-of-the-art gym. Located just a short distance from Rock Creek Academy, Mosaic at Miramar ensures that education and community are closely connected, providing a seamless living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, accent chairs, coffee table, and a TV on a cabinet.",
        "public_id": "019f6c0f-eb0a-709e-af6e-a75d42f42964",
        "storage_key": "property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rock Creek Academy Miramar",
      "seo_description": "Find stylish apartments near Rock Creek Academy Miramar at Mosaic. Enjoy modern amenities and convenient access to education and recreation.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "page_item_url": "apartments-close-to-nob-hill-academy-broward-880",
      "search_query": "apartments close to Nob Hill Academy Broward County",
      "category": "School",
      "h1_title": "Apartments Close to Nob Hill Academy",
      "h2_subtitle": "Find comfortable apartments close to Nob Hill Academy in Broward County. Mosaic offers family-oriented amenities and a great location.",
      "page_copy": "At Mosaic at Miramar Town Center, you'll find apartments close to Nob Hill Academy Broward County, providing a perfect blend of location and lifestyle. Our community is ideal for families and professionals seeking proximity to quality education and convenient living.\n\nChoose from our selection of thoughtfully designed one, two, and three-bedroom units that feature modern comforts such as in-unit washers and dryers. With a range of amenities, including a sparkling pool and a fully-equipped fitness center, Mosaic ensures a well-rounded living experience. Enjoy living in a vibrant neighborhood with easy access to educational institutions and other local attractions.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, accent chairs, coffee table, and a TV on a cabinet.",
        "public_id": "019f6c0f-eb0a-709e-af6e-a75d42f42964",
        "storage_key": "property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Nob Hill Academy",
      "seo_description": "Discover comfortable apartments close to Nob Hill Academy in Broward County. Mosaic provides modern living with family-friendly amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "page_item_url": "rentals-near-world-of-knowledge-preschool-826",
      "search_query": "rentals near A World of Knowledge Preschool Miramar",
      "category": "School",
      "h1_title": "Rentals Near A World of Knowledge Preschool",
      "h2_subtitle": "Explore charming rentals near A World of Knowledge Preschool in Miramar. Mosaic offers a welcoming community and modern amenities.",
      "page_copy": "Mosaic at Miramar Town Center presents the perfect opportunity for families looking for rentals near A World of Knowledge Preschool in Miramar, FL. Our community is designed to cater to both convenience and comfort, ensuring a seamless lifestyle.\n\nChoose from our range of inviting one, two, and three-bedroom floor plans, all of which include desirable features like in-unit washers and dryers. Spend your leisure time lounging by our shimmering pool or maintaining your fitness routine in our updated gym. Located just minutes from A World of Knowledge Preschool, Mosaic provides an enriching environment for growing families while placing education within easy reach.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, accent chairs, coffee table, and a TV on a cabinet.",
        "public_id": "019f6c0f-eb0a-709e-af6e-a75d42f42964",
        "storage_key": "property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near A World of Knowledge Preschool",
      "seo_description": "Find charming rentals near A World of Knowledge Preschool in Miramar. Mosaic offers a welcoming atmosphere with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "page_item_url": "apartments-near-conservatory-prep-schools-fl-830",
      "search_query": "apartments near Conservatory Prep Schools FL",
      "category": "School",
      "h1_title": "Apartments Near Conservatory Prep Schools",
      "h2_subtitle": "Find top-notch apartments near Conservatory Prep Schools FL. Mosaic offers the perfect blend of comfort and convenience.",
      "page_copy": "Mosaic at Miramar Town Center is the ideal location for those seeking apartments near Conservatory Prep Schools FL. Our vibrant community offers a harmonious blend of modern convenience and educational proximity, making it an excellent choice for families and individuals alike.\n\nSelect from our stylish one, two, or three-bedroom apartments equipped with amenities such as in-unit washers and dryers and vinyl plank flooring. Residents can unwind with serene water views or stay active in our state-of-the-art fitness center. With Conservatory Prep Schools just a short drive away, Mosaic ensures you have easy access to quality education while enjoying a luxurious lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, accent chairs, coffee table, and a TV on a cabinet.",
        "public_id": "019f6c0f-eb0a-709e-af6e-a75d42f42964",
        "storage_key": "property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Conservatory Prep Schools FL",
      "seo_description": "Discover superior apartments near Conservatory Prep Schools FL at Mosaic, featuring modern amenities and convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "page_item_url": "rentals-close-to-griffin-elementary-school-337",
      "search_query": "rentals close to Griffin Elementary School Miramar",
      "category": "School",
      "h1_title": "Rentals Close to Griffin Elementary School",
      "h2_subtitle": "Discover comfortable rentals close to Griffin Elementary School in Miramar. Mosaic offers family-friendly amenities in a prime location.",
      "page_copy": "Located in the heart of Miramar, Mosaic at Miramar Town Center offers exceptional rentals close to Griffin Elementary School. Our community is perfectly positioned for families seeking quality education and modern living conveniences.\n\nChoose from a variety of spacious one, two, and three-bedroom floor plans, each designed with comfort in mind and featuring in-unit washers and dryers. Enjoy amenities such as a shimmering pool and scenic lake views, creating an ideal setting for relaxation. With Griffin Elementary School just moments away, living at Mosaic ensures that education and home life blend seamlessly in a welcoming community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, accent chairs, coffee table, and a TV on a cabinet.",
        "public_id": "019f6c0f-eb0a-709e-af6e-a75d42f42964",
        "storage_key": "property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to Griffin Elementary School Miramar",
      "seo_description": "Explore rentals close to Griffin Elementary School in Miramar at Mosaic, offering modern living and family-friendly amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5174219562287104",
      "source": "custom",
      "page_item_url": "apartments-near-pembroke-pines-city-high-school-91",
      "search_query": "apartments near Pembroke Pines City of High School",
      "category": "School",
      "h1_title": "Apartments Near Pembroke Pines City High School",
      "h2_subtitle": "Find ideal apartments near Pembroke Pines City of High School. Mosaic provides modern living in a convenient location.",
      "page_copy": "Mosaic at Miramar Town Center is the perfect choice for those seeking apartments near Pembroke Pines City of High School. Our community offers an unbeatable combination of location, comfort, and modern amenities, making it ideal for families and students alike.\n\nChoose from our range of stylish one, two, and three-bedroom apartments, all featuring contemporary amenities like in-unit washers and dryers and vinyl plank flooring. Residents benefit from a variety of features including a state-of-the-art fitness center and serene water views. Located just a short distance from Pembroke Pines City of High School, Mosaic ensures quick access to education while offering a vibrant living environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
      "featured_image_media": {
        "alt_text": "Living room with a white sofa, accent chairs, coffee table, and a TV on a cabinet.",
        "public_id": "019f6c0f-eb0a-709e-af6e-a75d42f42964",
        "storage_key": "property/5174219562287104/019f6c0f-eb0a-709e-af6e-a75d42f42964.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pembroke Pines City High School",
      "seo_description": "Discover convenient apartments near Pembroke Pines City of High School at Mosaic, offering modern amenities and close proximity to education.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2293"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2505043710"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a3b\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a3b\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4980088"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WRQBL3P"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8384315033"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "1f1e62a4b7280861"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/27vqrl03pox"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/c6a5b465-1fe1-4acb-b0fd-cb26c0b89f8f"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "754-714-3947"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkNBWDJlR25ES2dFOEhSSm9pQVA3UEE9PSIsInZhbHVlIjoiMklEME1PcjREV3pKbFYwN3gwd21wUT09IiwibWFjIjoiMGUzMWE2MTNkODg4YzFiZTNiZGNlODI3MDU4NmQwZTkwZDUzODgwNzgwMzNiNjg5Y2FmNzNhYzM1ODViYWM3MyJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2293",
  "custom_repli_id": "2505043710",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a3b\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a3b\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4980088",
  "custom_google_gtm_id": "GTM-WRQBL3P",
  "custom_rollout_phase": "2",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8384315033",
  "custom_knock_community_id": "1f1e62a4b7280861",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/27vqrl03pox",
  "custom_self_guided_tour_url": "https://selftournow.com/property/c6a5b465-1fe1-4acb-b0fd-cb26c0b89f8f",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "754-714-3947",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkNBWDJlR25ES2dFOEhSSm9pQVA3UEE9PSIsInZhbHVlIjoiMklEME1PcjREV3pKbFYwN3gwd21wUT09IiwibWFjIjoiMGUzMWE2MTNkODg4YzFiZTNiZGNlODI3MDU4NmQwZTkwZDUzODgwNzgwMzNiNjg5Y2FmNzNhYzM1ODViYWM3MyJ9",
  "custom_household_income_qualification_multiplier": "3"
};

export const generatedAt = '2026-10-09T16:38:03.085Z';
